import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    Funnel,
    Edit2,
    Plus,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    SquareArrowOutUpRight,
    CircleCheck
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import noBrandImage from '../../assets/img/brand/no-brand-img.png';
import apiHelper from '../../apiHelper';
import { prefetchSpuNames } from '../../spuValidationCache';
import noImage from '../../assets/img/brand/noImage.png';
import DynamicTable from '../../components/DynamicTable';
import { useLoader } from '../../components/GlobalLoader';
import noSpuImage from '../../assets/img/brand/no-brand-img.png';
import emptySearchImg from '../../assets/img/brand/empty-search.png';
import Pagination from '../../components/Pagination';
import FilterDrawer from '../../components/FilterDrawer';
import MultiSelectSearch from '../../utils/MultiSelectSearch';
import { formatDateTime } from '../../utils/formateDate';
import SearchBox from '../../components/SearchBox';
import ConfirmArchiveModal from '../../components/ConfirmArchiveModal';
import ConfirmDeactivateModal from '../../components/ConfirmDeactivateModal';
import BrandInfoDrawer from '../../components/BrandInfoDrawer';
import CategoryInfoDrawer from '../../components/CategoryInfoDrawer';
import AlertNotification from '../../components/AlertNotification';
const PAGE_SIZE = 10;

export default function Spusku() {
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.restoreTab || 'spu');
    const ITEMS_PER_PAGE = 5;
    const SKU_VARIATIONS_PER_PAGE = 5;
    const [skuVariationPage, setSkuVariationPage] = useState(1);
    const breadcrumbs = ["Product", "SPU & SKU"];
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(
        location.state?.restoreTab !== 'archived-spu' ? (location.state?.restorePage || 1) : 1
    );
    const [searchInput, setSearchInput] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [archivedSearchTerm, setArchivedSearchTerm] = useState('');
    const [archivedSearchInput, setArchivedSearchInput] = useState('');
    const [archivedCurrentPage, setArchivedCurrentPage] = useState(
        location.state?.restoreTab === 'archived-spu' ? (location.state?.restorePage || 1) : 1
    );
    const [archivedSelectedIds, setarchivedSelectedIds] = useState([]);
    const [currentSkuCount, setCurrentSkuCount] = useState(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const [archivedFilterOpen, setArchivedFilterOpen] = useState(false);
    const [brands, setBrands] = useState([]);
    const [presetLabels, setPresetLabels] = useState({});
    const [optionLabels, setOptionLabels] = useState({});
    const [skuVariations, setSkuVariations] = useState([]);
    const [selectedSpu, setSelectedSpu] = useState(null);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [previewIndex, setPreviewIndex] = useState(0);
    const [skuDrawerOpen, setSkuDrawerOpen] = useState(false);
    const [skuTab, setSkuTab] = useState('general');
    const [copied, setCopied] = useState(false);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const archivedRef = useRef(null);
    const hasRestoredDrawer = useRef(false);
    const isFirstSearchRender = useRef(true);
    const isFirstArchivedSearchRender = useRef(true);
    const isFirstLoad = useRef(true);
    const prefetchCache = useRef(new Map());
    const prefetchInProgress = useRef(new Set());
    const isFirstArchivedLoad = useRef(true);
    const { showLoader, hideLoader } = useLoader();
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedParentBrands, setSelectedParentBrands] = useState([]);
    const toolbarRef = useRef(null);
    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const [selectedSkuRow, setSelectedSkuRow] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerData, setDrawerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasAutoOpened, setHasAutoOpened] = useState(false);
    const [sortField, setSortField] = useState('modified_at');
    const [sortOrder, setSortOrder] = useState("desc");
    const SKU_CONFIGS_PER_PAGE = 5;
    const [skuConfigPage, setSkuConfigPage] = useState(1);
    const [filters, setFilters] = useState({
        status: [],
        brand: [],
        category: [],
        type: [],
        brandSearch: "",
        categorySearch: "",
        typeSearch: ""
    });
    // Add a new state for archived SKU setup data
    const [archivedSkuSetupData, setArchivedSkuSetupData] = useState({
        variations: [],
        configurations: [],
        presetMap: {},
        optionMap: {}
    });
    const [archivedFilters, setArchivedFilters] = useState({
        brand: [],
        category: [],
        type: [],
        brandSearch: "",
        categorySearch: "",
        typeSearch: ""
    });

    const [brandSearchTerm, setBrandSearchTerm] = useState('');
    const [archivedBrandSearchTerm, setArchivedBrandSearchTerm] = useState('');
    const filterRef = useRef(null);
    const archivedFilterRef = useRef(null);
    const filterButtonRef = useRef(null);
    const archivedFilterButtonRef = useRef(null);
    const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
    const [archivedFilterPosition, setArchivedFilterPosition] = useState({ top: 0, left: 0 });

    const [suppressHighlight, setSuppressHighlight] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [validationError, setValidationError] = useState([]);
    const [brandsData, setBrandsData] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState('general');
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedBrandRow, setSelectedBrandRow] = useState(null);
    const [selectedCategoryRow, setSelectedCategoryRow] = useState(null);
    const [spus, setSpus] = useState([]);
    const [archivedSpus, setArchivedSpus] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [archivedTotalCount, setArchivedTotalCount] = useState(0);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [archivedDebouncedSearch, setArchivedDebouncedSearch] = useState('');
    const [archivedRefreshKey, setArchivedRefreshKey] = useState(0);
    const [filterOptions, setFilterOptions] = useState({ brands: [], categories: [], types: [] });
    const [archivedFilterOptions, setArchivedFilterOptions] = useState({ brands: [], categories: [], types: [] });
    const [archivedSortConfig, setArchivedSortConfig] = useState({ key: 'archived_at', direction: 'desc' });
    const [selectedSpuId, setSelectedSpuId] = useState(null);
    const [skuDetails, setSkuDetails] = useState([]);
    const [alert, setAlert] = useState(null);
    const [showItemAlert, setShowItemAlert] = useState(false);

    const [tempValues, setTempValues] = useState({
        status: [],
        brand: [],
        category: [],
        type: [],
        brandSearch: "",
        categorySearch: "",
        typeSearch: ""
    });
    const [tempArchivedValues, setTempArchivedValues] = useState({
        brand: [],
        category: [],
        type: [],
        brandSearch: "",
        categorySearch: "",
        typeSearch: ""
    });


    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
    const [actionSpuId, setActionSpuId] = useState(null);
    const [actionFromDrawer, setActionFromDrawer] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        type: '',
        recordName: '',
        action: ''
    });
    const [brandDrawerOpen, setBrandDrawerOpen] = useState(false);
    const [categoryDrawerOpen, setCategoryDrawerOpen] = useState(false);
    // Handler for opening deactivate modal
    // Handler for deactivate/activate actions
    const handleDeactivateClick = async (spuId, fromDrawer = false) => {
        const spuToUpdate = spus.find(spu => spu.spu_id === spuId);
        if (!spuToUpdate) {
            console.error('SPU not found');
            return;
        }

        // If activating (status is Inactive), activate directly without modal
        if (spuToUpdate.status === 'Inactive') {
            await handleActivateDeactivate(spuId, true, fromDrawer);
            setDropdownOpenId(null); // FIXED : The action popup should close when the SPU is activated.
        } else {
            // If deactivating (status is Active), show confirmation modal
            setActionSpuId(spuId);
            setActionFromDrawer(fromDrawer);
            setDeactivateModalOpen(true);
            setDropdownOpenId(null); // Close dropdown if open
            setToolbarDropdownOpen(false); // Close toolbar dropdown if open
        }
    };

    // Update handleActivateDeactivate function:
    const handleActivateDeactivate = async (spuId, activate, fromDrawer = false) => {
        try {
            const spuToUpdate = spus.find(spu => spu.spu_id === spuId);
            if (!spuToUpdate) {
                console.error('SPU not found');
                return;
            }

            const newStatus = activate; // true for active, false for inactive
            const response = await apiHelper(
                `inventory/spus/update/${spuId}/`,
                'POST',
                { status: newStatus }
            );

            if (response?.ok) {
                // Update local state
                setSpus(prev => prev?.map(spu =>
                    spu.spu_id === spuId
                        ? {
                            ...spu,
                            status: activate ? 'Active' : 'Inactive',
                            status_text: activate ? 'Active' : 'Inactive'
                        }
                        : spu
                ));

                // Update selectedRow if it's the same SPU and drawer is open
                if (selectedRow && selectedRow.spu_id === spuId) {
                    setSelectedRow(prev => ({
                        ...prev,
                        status: activate ? 'Active' : 'Inactive',
                        status_text: activate ? 'Active' : 'Inactive'
                    }));
                }

                // Show success notification
                setNotification({
                    show: true,
                    type: 'success',
                    recordName: 'SPU',
                    action: activate ? 'activate' : 'deactivate'
                });

                // Auto-hide notification after 5 seconds
                setTimeout(() => {
                    setNotification({ show: false, type: '', recordName: '', action: '' });
                }, 5000);
            } else {
                // Show error notification
                setNotification({
                    show: true,
                    type: 'error',
                    recordName: 'SPU',
                    action: activate ? 'activate' : 'deactivate'
                });
            }
        } catch (error) {
            console.error('Error updating SPU status:', error);
            setNotification({
                show: true,
                type: 'error',
                recordName: 'SPU',
                action: 'update'
            });
        } finally {
            setDeactivateModalOpen(false);
            setActionSpuId(null);
        }
    };
    // Handler for opening archive modal
    const handleArchiveClick = (spuId, fromDrawer = false) => {
        setActionSpuId(spuId);
        setActionFromDrawer(fromDrawer);
        setArchiveModalOpen(true);
        setDropdownOpenId(null); // Close dropdown if open
        setToolbarDropdownOpen(false); // Close toolbar dropdown if open
    };

    // Handler for confirming deactivate (from modal)
    const handleConfirmDeactivate = async () => {
        await handleActivateDeactivate(actionSpuId, false, actionFromDrawer);
    };

    // Handler for confirming archive
    const handleConfirmArchive = async () => {
        try {
            // Archive the SPU
            await handleArchiveSpus([actionSpuId]);

            // No need to fetch archived SPUs separately - they're already updated in handleArchiveSpus
        } catch (error) {
            console.error('Error archiving SPU:', error);
            setNotification({
                show: true,
                type: 'error',
                recordName: 'SPU',
                action: 'archive'
            });
        } finally {
            setArchiveModalOpen(false);
            setActionSpuId(null);
        }
    };

    // Handler for closing notification
    const handleCloseNotification = () => {
        setNotification({ show: false, type: '', recordName: '', action: '' });
    };
    // Warm up the SPU name-check cache so it's ready before the user clicks "Add SPU".
    useEffect(() => { prefetchSpuNames(); }, []);

    // Server-side fetch for archived SPUs
    useEffect(() => {
        if (activeTab !== 'archived-spu') return;
        async function loadArchived() {
            const isInitialArchived = isFirstArchivedLoad.current;
            if (isInitialArchived) { showLoader(); isFirstArchivedLoad.current = false; }
            try {
                const params = new URLSearchParams({ is_archived: 'true', page: archivedCurrentPage, page_size: PAGE_SIZE });
                if (archivedDebouncedSearch.trim()) params.set('search', archivedDebouncedSearch.trim());
                if (archivedFilters.brand?.length)    params.set('brand',    archivedFilters.brand.join(','));
                if (archivedFilters.category?.length) params.set('category', archivedFilters.category.join(','));
                if (archivedFilters.type?.length)     params.set('type',     archivedFilters.type.join(','));
                const sortKey = archivedSortConfig?.key || 'archived_at';
                const sortDir = archivedSortConfig?.direction || 'desc';
                params.set('ordering', `${sortDir === 'desc' ? '-' : ''}${sortKey}`);

                const response = await apiHelper(`inventory/spu-sku/archive-full/?${params}`);
                if (response?.ok) {
                    const result = await response.json();
                    const mapped = (result.results || []).map(item => ({
                        ...item,
                        category_name: item.category_hierarchy
                            ? item.category_hierarchy.map(c => c.name).join(' >> ')
                            : '',
                        brand_name: item.brand_hierarchy && item.brand_hierarchy.length > 0
                            ? item.brand_hierarchy.map(b => b.name).join(' >> ')
                            : (item.brand_name || ''),
                    }));
                    setArchivedSpus(mapped);
                    setArchivedTotalCount(result.count || 0);
                    if (result.filter_options) setArchivedFilterOptions(result.filter_options);
                } else {
                    setArchivedSpus([]);
                    setArchivedTotalCount(0);
                }
            } catch (error) {
                console.error('Failed to fetch archived SPUs:', error);
                setArchivedSpus([]);
            } finally {
                if (isInitialArchived) { hideLoader(); }
            }
        }
        loadArchived();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, archivedCurrentPage, archivedDebouncedSearch, archivedFilters, archivedSortConfig, archivedRefreshKey]);
    const fetchArchivedSpuSkuSetupData = async (spuId) => {
        try {
            const response = await apiHelper(`inventory/spu-sku/spu/${spuId}/sku-setup/?is_archived=true`);
            if (response?.ok) {
                const data = await response.json();
                setArchivedSkuSetupData(data);

                // Transform variations data for display
                const mappedVariations = data.variations.map(v => ({
                    name: v.preset_name,
                    options: v.options.map(opt => ({
                        id: opt.option_id,
                        label: opt.option_name
                    }))
                }));
                setSkuVariations(mappedVariations);

                // Transform configurations data - now with SKU names
                const mappedConfigurations = data.configurations.map(cfg => {
                    return {
                        configuration_id: cfg.configuration_id,
                        configuration_name: cfg.configuration_name,
                        skus: Array.isArray(cfg.skus) ? cfg.skus : []  // Array of SKU objects
                    };
                });

                console.log("Archived SKU Configurations with SKUs:", {
                    configurations: data.configurations,
                    mappedConfigurations: mappedConfigurations
                });

                setSkuConfigurations(mappedConfigurations);
            } else {
                console.error('Failed to fetch archived SPU SKU setup data');
                setSkuVariations([]);
                setSkuConfigurations([]);
            }
        } catch (error) {
            console.error('Error fetching archived SPU SKU setup:', error);
            setSkuVariations([]);
            setSkuConfigurations([]);
        }
    };
    const fetchSkuSetupData = async () => {
        try {
            let url = `inventory/spu-sku/spu/${selectedRow.spu_id}/sku-setup/`;

            // Add is_archived parameter only for archived SPUs
            if (activeTab === 'archived-spu') {
                url += '?is_archived=true';
            }

            const response = await apiHelper(url);
            if (response?.ok) {
                const data = await response.json();

                // Transform variations data for display
                const mappedVariations = data.variations.map(v => ({
                    name: v.preset_name,
                    options: v.options.map(opt => ({
                        id: opt.option_id,
                        label: opt.option_name
                    }))
                }));
                setSkuVariations(mappedVariations);

                // Transform configurations data with SKU names
                const mappedConfigurations = data.configurations.map(cfg => {
                    return {
                        configuration_id: cfg.configuration_id,
                        configuration_name: cfg.configuration_name,
                        skus: Array.isArray(cfg.skus) ? cfg.skus : []  // Array of SKU objects
                    };
                });

                console.log(`${activeTab} SKU Configurations with SKUs:`, {
                    configurations: data.configurations,
                    mappedConfigurations: mappedConfigurations
                });

                setSkuConfigurations(mappedConfigurations);
            } else {
                console.error('Failed to fetch SPU SKU setup data');
                setSkuVariations([]);
                setSkuConfigurations([]);
            }
        } catch (error) {
            console.error('Error fetching SPU SKU setup:', error);
            setSkuVariations([]);
            setSkuConfigurations([]);
        }
    };

    // Update the useEffect for SKU setup data to use the new API for both active and archived SPUs
    useEffect(() => {
        if (drawerOpen && selectedRow) {
            if (activeTab === 'spu') {
                // For Active SPU drawer - use the new API
                fetchSkuSetupData(selectedRow.spu_id);
            } else if (activeTab === 'archived-spu') {
                // For Archived SPU drawer - use the archived API
                fetchArchivedSpuSkuSetupData(selectedRow.spu_id);
            }
        }
    }, [selectedRow, activeTab, drawerOpen]);

    useEffect(() => {
        if (location.state?.alert) {
            setAlert(location.state.alert);
            setShowItemAlert(true);

            // clear history state (important)
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    // Restore SPU drawer when navigating back from SKU page via drawer
    useEffect(() => {
        const openSpuId = location.state?.openSpuId;
        const restoreTab = location.state?.restoreTab;
        if (!openSpuId || hasRestoredDrawer.current) return;
        const targetSpus = restoreTab === 'archived-spu' ? archivedSpus : spus;
        if (!targetSpus.length) return;
        const spu = targetSpus.find(s => String(s.spu_id) === String(openSpuId));
        if (spu) {
            setSelectedRow(spu);
            setDrawerOpen(true);
            hasRestoredDrawer.current = true;
            window.history.replaceState({}, document.title);
        }
    }, [location.state, spus, archivedSpus]);

    // Search debounce effects
    useEffect(() => {
        if (isFirstSearchRender.current) {
            isFirstSearchRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        if (isFirstArchivedSearchRender.current) {
            isFirstArchivedSearchRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            setArchivedDebouncedSearch(archivedSearchTerm);
            setArchivedCurrentPage(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [archivedSearchTerm]);

    function buildSpuCacheKey(page, search, filtersObj, sf, so) {
        return JSON.stringify({ page, search: search.trim(), filters: filtersObj, sortField: sf, sortOrder: so });
    }

    async function prefetchSpuPage(page, search, filtersObj, sf, so, count) {
        const totalPages = Math.ceil(count / PAGE_SIZE);
        if (page > totalPages) return;
        const key = buildSpuCacheKey(page, search, filtersObj, sf, so);
        if (prefetchCache.current.has(key) || prefetchInProgress.current.has(key)) return;
        prefetchInProgress.current.add(key);
        try {
            const params = new URLSearchParams({ page, page_size: PAGE_SIZE });
            if (search.trim()) params.set('search', search.trim());
            if (filtersObj.status?.length)   params.set('status',   filtersObj.status.join(','));
            if (filtersObj.brand?.length)    params.set('brand',    filtersObj.brand.join(','));
            if (filtersObj.category?.length) params.set('category', filtersObj.category.join(','));
            if (filtersObj.type?.length)     params.set('type',     filtersObj.type.join(','));
            params.set('ordering', `${so === 'desc' ? '-' : ''}${sf}`);
            const res = await apiHelper(`inventory/spu-sku/full/?${params}`, 'GET');
            if (res.ok) {
                const json = await res.json();
                const mapped = (json.results || []).map(item => ({
                    ...item,
                    category_name: item.category_hierarchy
                        ? item.category_hierarchy.map(c => c.name).join(' >> ')
                        : '',
                    brand_name: item.brand_hierarchy && item.brand_hierarchy.length > 0
                        ? item.brand_hierarchy.map(b => b.name).join(' >> ')
                        : (item.brand_name || ''),
                }));
                prefetchCache.current.set(key, { mapped, count: json.count || 0, filter_options: json.filter_options });
            }
        } catch (_) {
            // silent — background prefetch failures should not affect the UI
        } finally {
            prefetchInProgress.current.delete(key);
        }
    }

    // Clear prefetch cache whenever search/filter/sort params change (not page)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        prefetchCache.current.clear();
        prefetchInProgress.current.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch, filters, sortField, sortOrder]);

    // Server-side fetch for active SPUs
    useEffect(() => {
        async function load() {
            const cacheKey = buildSpuCacheKey(currentPage, debouncedSearch, filters, sortField, sortOrder);
            const cached = prefetchCache.current.get(cacheKey);

            if (cached) {
                setSpus(cached.mapped);
                setTotalCount(cached.count);
                if (cached.filter_options) setFilterOptions(cached.filter_options);
                setIsLoading(false);
                prefetchSpuPage(currentPage + 1, debouncedSearch, filters, sortField, sortOrder, cached.count);
                return;
            }

            const isInitial = isFirstLoad.current;
            if (isInitial) { showLoader(); isFirstLoad.current = false; }
            setIsLoading(true);
            try {
                const params = new URLSearchParams({ page: currentPage, page_size: PAGE_SIZE });
                if (debouncedSearch.trim()) params.set('search', debouncedSearch.trim());
                if (filters.status?.length)   params.set('status',   filters.status.join(','));
                if (filters.brand?.length)    params.set('brand',    filters.brand.join(','));
                if (filters.category?.length) params.set('category', filters.category.join(','));
                if (filters.type?.length)     params.set('type',     filters.type.join(','));
                params.set('ordering', `${sortOrder === 'desc' ? '-' : ''}${sortField}`);

                const response = await apiHelper(`inventory/spu-sku/full/?${params}`, 'GET');
                if (response.ok) {
                    const data = await response.json();
                    const mapped = (data.results || []).map(item => ({
                        ...item,
                        category_name: item.category_hierarchy
                            ? item.category_hierarchy.map(c => c.name).join(' >> ')
                            : '',
                        brand_name: item.brand_hierarchy && item.brand_hierarchy.length > 0
                            ? item.brand_hierarchy.map(b => b.name).join(' >> ')
                            : (item.brand_name || ''),
                    }));
                    setSpus(mapped);
                    setTotalCount(data.count || 0);
                    if (data.filter_options) {
                        setFilterOptions(data.filter_options);
                    }
                    // Prefetch the next page in the background
                    prefetchSpuPage(currentPage + 1, debouncedSearch, filters, sortField, sortOrder, data.count || 0);
                } else {
                    console.error('Failed to fetch SPU-SKU data');
                }
            } catch (error) {
                console.error('Failed to fetch SPUs:', error);
            } finally {
                setIsLoading(false);
                if (isInitial) { hideLoader(); }
            }
        }
        load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, debouncedSearch, filters, sortField, sortOrder]);

    useEffect(() => {
        function handleClickOutside(event) {
            setTimeout(() => {
                if (
                    filterOpen &&
                    filterRef.current &&
                    !filterRef.current.contains(event.target) &&
                    filterButtonRef.current &&
                    !filterButtonRef.current.contains(event.target)
                ) {
                    console.log('Closing filter popup due to outside click');
                    setFilterOpen(false);
                }
                if (
                    archivedFilterOpen &&
                    archivedFilterRef.current &&
                    !archivedFilterRef.current.contains(event.target) &&
                    archivedFilterButtonRef.current &&
                    !archivedFilterButtonRef.current.contains(event.target)
                ) {
                    console.log('Closing archived filter popup due to outside click');
                    setArchivedFilterOpen(false);
                }
            }, 0);
        }

        if (filterOpen || archivedFilterOpen) {
            console.log('Adding mousedown listener for handleClickOutside');
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                console.log('Removing mousedown listener for handleClickOutside');
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [filterOpen, archivedFilterOpen]);
    useEffect(() => {
        if (filterOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX
            });
        }
    }, [filterOpen]);

    useEffect(() => {
        if (archivedFilterOpen && archivedFilterButtonRef.current) {
            const rect = archivedFilterButtonRef.current.getBoundingClientRect();
            setArchivedFilterPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX
            });
        }
    }, [archivedFilterOpen]);

    const filterSpus = (list, searchTerm, filters) => {
        if (!list) return [];

        const keywords = (searchTerm || "").toLowerCase().split(/[,\s]+/).filter(Boolean);

        return list.filter(d => {
            let match = true;

            // 👉 SEARCH
            if (keywords.length > 0) {

                const searchableWords = [
                    d.model_name,
                    d.model_id,
                    d.prefix
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase()
                    .split(/\s+/)        // convert to words array
                    .filter(Boolean);

                const matchText = keywords.some(word => searchableWords.includes(word));

                match = match && matchText;
            }

            // 👉 STATUS (Active / Inactive)
            if (filters?.status?.length > 0) {
                match = match && filters?.status?.includes(d?.status);
            }

            // 👉 BRAND (brand_id)
            if (filters.brand?.length > 0) {
                match = match && filters?.brand?.includes(d.brand_id);
            }

            // 👉 CATEGORY (category_id)
            if (filters.category?.length > 0) {
                match = match && filters?.category?.includes(parseInt(d.category_id));
            }

            // 👉 TYPE (os_type)
            if (filters.type?.length > 0) {
                match = match && filters?.type.includes(d.product_type);
            }

            return match;
        });
    };

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const sortData = (data, key, direction) => {
        return [...data].sort((a, b) => {
            const valueA = a[key] || '';
            const valueB = b[key] || '';
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return direction === 'asc'
                    ? valueA?.toLowerCase().localeCompare(valueB?.toLowerCase())
                    : valueB?.toLowerCase().localeCompare(valueA?.toLowerCase());
            }
            return direction === 'asc' ? valueA - valueB : valueB - valueA;
        });
    };

    // Add this useEffect to set default sorting when data loads or activeTab changes
    // Server-side: data is already filtered, sorted, and paginated
    const pageData         = spus;
    const archivedPageData = archivedSpus;
    const totalPages         = Math.ceil(totalCount / PAGE_SIZE);
    const archivedTotalPages = Math.ceil(archivedTotalCount / PAGE_SIZE);

    // Filter counts
    // const filterCount = filters.brandName.length + filters.status.length;
    // const archivedFilterCount = archivedFilters.brandName.length + archivedFilters.status.length;
    // Add this useEffect after your existing useEffect for fetching sku attributes
    const [skuConfigurations, setSkuConfigurations] = useState([]);

    // Update the useEffect for SKU setup data - REMOVING OLD LOGIC
    useEffect(() => {
        // This useEffect is now handled by the new fetchActiveSpuSkuSetupData function
        // called in the main useEffect above
    }, [selectedRow, activeTab, drawerOpen]); // Add archivedSkuSetupData as dependency

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
                setToolbarDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleSelect = id => {
        setSelectedIds(ids => {
            const newIds = ids.includes(id)
                ? ids.filter(x => x !== id)
                : [...ids, id];
            setSuppressHighlight(false);
            return newIds;
        });
    };

    const toggleAll = () => {
        setSelectedIds(prev => {
            const next =
                prev.length === pageData.length
                    ? []
                    : pageData.map(d => d.spu_id);
            setSuppressHighlight(false);
            return next;
        });
    };

    const onRowClick = (row) => {
        setSelectedRow(row);
        setSelectedCategoryRow(categoriesData.find((d) => d.category_id === row.category_id));
        setSelectedBrandRow(brandsData.find((d) => d.brand_id === row.brand_id));
        setSelectedSpu(row);
        setDrawerTab('general');
        setDrawerOpen(true);
    };

    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRefs = useRef({});
    const drawerRef = useRef(null);
    console.log("dropdownOpenId", dropdownOpenId);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                filterOpen &&
                filterRef.current &&
                !filterRef.current.contains(event.target) &&
                filterButtonRef.current &&
                !filterButtonRef.current.contains(event.target)
            ) {
                console.log('Closing filter popup due to outside click');
                setFilterOpen(false);
            }
            if (
                archivedFilterOpen &&
                archivedFilterRef.current &&
                !archivedFilterRef.current.contains(event.target) &&
                archivedFilterButtonRef.current &&
                !archivedFilterButtonRef.current.contains(event.target)
            ) {
                console.log('Closing archived filter popup due to outside click');
                setArchivedFilterOpen(false);
            }

            // Close dropdown when clicking outside
            if (
                dropdownOpenId !== null &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !buttonRefs.current[dropdownOpenId]?.contains(event.target)
            ) {
                setDropdownOpenId(null);
            }
        }

        if (filterOpen || archivedFilterOpen || dropdownOpenId !== null) {
            console.log('Adding mousedown listener for handleClickOutside');
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                console.log('Removing mousedown listener for handleClickOutside');
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [filterOpen, archivedFilterOpen, dropdownOpenId]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }

        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);

    useEffect(() => {
        if (filterOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX
            });
        }
    }, [filterOpen]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }

        if (saveModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [saveModalOpen]);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const spuId = query.get('id');
        const autoOpen = query.get('autoOpen') === 'true';
        const tab = query.get('tab');

        if (spuId && autoOpen && !hasAutoOpened) {
            console.log("open from brand", spuId, autoOpen, hasAutoOpened)
            const spu = spus.find((s) => s.spu_id == spuId);
            console.log("spus", spus)
            if (spu) {
                console.log("in spu")
                setSelectedRow(spu);
                setDrawerOpen(true);
                // setDrawerTab(tab || 'entity-info');
                setHasAutoOpened(true);
            } else {
                console.warn(`SPU with ID ${spuId} not found`);
            }
        }
    }, [location.search, spus, hasAutoOpened, isLoading]);
    useEffect(() => {
        if (skuDrawerOpen && selectedRow) {
            async function fetchSkuDetails() {
                try {
                    const response = await apiHelper(`inventory/sku/spu/${selectedRow.spu_id}/`);
                    if (response && response.ok) {
                        const skus = await response.json();
                        setSkuDetails(skus);
                    } else {
                        setSkuDetails([]);
                    }
                } catch (error) {
                    console.error(`Failed to fetch SKUs for SPU ${selectedRow.spu_id}:`, error);
                    setSkuDetails([]);
                }
            }
            fetchSkuDetails();
        }
    }, [skuDrawerOpen, selectedRow]);
    useEffect(() => {
        // debug log to check what's coming in
        console.log('location.state on mount:', location.state);

        if (location && location.state && location.state.success) {
            setSuccessMessage(location.state.success);

            // clear that location.state so it doesn't reappear on refresh/back
            // for react-router v5: history.replace(pathname, state)
            history.replace(location.pathname, {});

            // auto-hide the success message after 3-4s
            const t = setTimeout(() => setSuccessMessage(''), 4000);
            return () => clearTimeout(t);
        }
    }, [location, history]);


    useEffect(() => {
        if (successMessage) {
            const t = setTimeout(() => setSuccessMessage(""), 4000);
            return () => clearTimeout(t);
        }
    }, [successMessage]);
    useEffect(() => {
        if (archivedFilterOpen && archivedFilterButtonRef.current) {
            const rect = archivedFilterButtonRef.current.getBoundingClientRect();
            setArchivedFilterPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX
            });
        }
    }, [archivedFilterOpen]);

    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    // const currentRow = spus.find(e => e.spu_id === dropdownOpenId);
    const currentRow = activeTab === 'spu'
        ? spus?.find(e => e.spu_id === dropdownOpenId)
        : archivedSpus?.find(e => e.spu_id === dropdownOpenId);
    const editSpu = () => {
        if (selectedIds.length === 1) {
            history.push(`/spu-sku/edit-spu/${selectedIds[0]}`,
                {
                    state: {
                        spus, // 👈 pass full SPU list here
                    }
                });
        }
        else if (dropdownOpenId) {
            history.push(`/spu-sku/edit-spu/${dropdownOpenId}`,
                {
                    state: {
                        spus, // 👈 pass full SPU list here
                    }
                });
        }
        else if (selectedRow) {
            history.push(`/spu-sku/edit-spu/${selectedRow.spu_id}`,
                {
                    state: {
                        spus, // 👈 pass full SPU list here
                    }
                });
        }
    }
    useEffect(() => {
        async function fetchInitialData() {

            try {
                const brandsRes = await apiHelper('inventory/brands/?is_archived=false', 'GET');
                if (brandsRes.ok) {
                    const result = await brandsRes.json();
                    let sampleData = result.map(item => {
                        const parentBrand = result.find(m => m.brand_id == item.parent_brand?.toString());
                        return {
                            ...item,
                            status_name: item.status == 1 ? 'Active' : 'Inactive',
                            parent_brand_name: parentBrand ? parentBrand.brand_name : '',
                        };
                    });
                    setBrandsData(sampleData);
                } else {
                    console.error('API returned non-ok response', brandsRes.status);
                }
            } catch (error) {
                console.error('Failed to fetch initial data:', error);
            }
        }


        const fetchCategories = async () => {
            try {
                const response = await apiHelper('inventory/categories/?is_archived=false', 'GET');
                if (response.ok) {
                    const data = await response.json();
                    console.log("Categories fetched:", data);
                    setCategoriesData(deduplicateById(data));
                } else {
                    const error = await response.json();
                    console.error("Failed to fetch categories:", error);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchInitialData();
        fetchCategories();
    }, []);
    const deduplicateById = (data) => {
        const seen = new Set();
        return data.filter(item => {
            if (!item.category_id) return false;
            if (seen.has(item.category_id)) return false;
            seen.add(item.category_id);
            return true;
        });
    };

    const toggleDropdown = (id) => {
        console.log("Toggling dropdown for ID:", id);
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
            setCurrentSkuCount(null); // Reset count when closing dropdown
        } else {
            const btn = buttonRefs.current[id];
            if (btn) {
                const rect = btn.getBoundingClientRect();
                const dropdownWidth = 150;
                const dropdownHeight = 100;

                let left = rect.left + window.scrollX - dropdownWidth + rect.width;
                if (left < window.scrollX + 8) {
                    left = window.scrollX + 8;
                }

                let top = rect.bottom + window.scrollY;
                if (top + dropdownHeight > window.scrollY + window.innerHeight) {
                    top = rect.top + window.scrollY - dropdownHeight;
                }

                setDropdownPosition({ top, left });
            }
            setDropdownOpenId(id);
            // Fetch SKU count for the specific SPU
            apiHelper(`inventory/sku/spu/${id}/`)
                .then(response => {
                    if (response && response.ok) {
                        return response.json();
                    }
                    throw new Error('Failed to fetch SKUs');
                })
                .then(skus => {
                    setCurrentSkuCount(skus.length);
                })
                .catch(error => {
                    console.error(`Failed to fetch SKU count for SPU ${id}:`, error);
                    setCurrentSkuCount(0);
                });
        }
    };

    const handleViewSku = (row) => {
        if (activeTab === 'archived-spu') {
            // Navigate to archived SKUs view
            history.push(`/inventory/spus/${row?.spu_id}/skus`, {
                spu: row,
                archived: true,
                from: 'archived-spu'
            });
        } else {
            setSelectedRow(row);
            setSkuDrawerOpen(true);
        }
        setDropdownOpenId(null); // Close the dropdown
    };

    const filtersApplied =
        (filters.status?.length || 0) > 0 ||
        (filters.brand?.length || 0) > 0 ||
        (filters.category?.length || 0) > 0 ||
        (filters.type?.length || 0) > 0;


    const archivedFiltersApplied =
        (archivedFilters.status?.length || 0) > 0 ||
        (archivedFilters.brand?.length || 0) > 0 ||
        (archivedFilters.category?.length || 0) > 0 ||
        (archivedFilters.type?.length || 0) > 0;

    const handleArchivedConfirm = () => {
        console.log("Archiving:", selectedEmployeeId);
        setArchivedModalOpen(false);
    };

    const handleDiscard = () => {
        history.goBack();
    };

    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };
    const formattedDate = selectedRow?.release_date
        ? new Date(selectedRow.release_date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        })
        : <span style={{ color: '#B0B0B0' }}>NA</span>;

    const handleSaveConfirm = () => {
        setSaveModalOpen(false);
    };

    async function handleCategoryClick(categoryId) {
        const res = await apiHelper(`inventory/categories/show/${categoryId}/`, 'GET');
        const data = await res.json(); // if apiHelper returns fetch response
        openCategoryDrawer(data); // update drawer state
    }


    function openCategoryDrawer(data) {
        setDrawerData(data);
        setIsDrawerOpen(true);
    }
    // In Spusku component, add this with other state declarations

    const handleCopy = async (textToCopy) => {
        if (!textToCopy) {
            console.error('No text to copy');
            // alert('Failed to copy: No text available.');
            return;
        }

        // Use Clipboard API if available and secure
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
                await navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            } catch (err) {
                console.error('Clipboard API failed:', err);
                fallbackCopyTextToClipboard(textToCopy);
            }
        } else {
            console.warn('Clipboard API not available or not in secure context, using fallback');
            fallbackCopyTextToClipboard(textToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy text. Please copy manually.');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            alert('Failed to copy text. Please copy manually.');
        }
    };



    async function handleArchiveSpus(spuIds) {
        try {
            const response = await apiHelper(
                'inventory/spus/archive/',
                'POST',
                { spu_ids: spuIds, archive: true }
            );

            const data = await response.json();

            if (response.ok) {
                // Success case
                // 1. Find the SPU(s) being archived from active list
                const archivedSpusData = spus.filter(spu => spuIds.includes(spu.spu_id));

                // 2. Remove archived ones from active list
                setSpus(prev => prev.filter(spu => !spuIds.includes(spu.spu_id)));
                setTotalCount(prev => Math.max(0, prev - spuIds.length));

                // 3. Trigger re-fetch of archived list when user visits that tab
                setArchivedRefreshKey(k => k + 1);

                setSelectedIds([]);

                // 4. If archiving from drawer, update the drawer content
                if (actionFromDrawer && selectedRow) {
                    // Update selectedRow to reflect it's archived
                    setSelectedRow(prev => ({
                        ...prev,
                        archived_at: new Date().toISOString(),
                        archived_by: "Current User"
                    }));
                }

                // Show success notification
                setNotification({
                    show: true,
                    type: 'success',
                    recordName: 'SPU',
                    action: 'archive'
                });

                // Auto-hide notification after 5 seconds
                setTimeout(() => {
                    setNotification({ show: false, type: '', recordName: '', action: '' });
                }, 5000);

                // Close drawer only if not from drawer action
                if (!actionFromDrawer) {
                    setDrawerOpen(false);
                    setSelectedRow(null);
                }
            } else {
                // Check if it's a stock-related error
                const errorMsg = data.error || 'Failed to archive SPU';
                const errorDetails = data.details || {};

                // Check if error indicates SKUs have stock
                if (errorMsg.includes('Cannot archive SPU because related SKUs have stock records') ||
                    errorMsg.includes('stock') ||
                    errorMsg.includes('Stock') ||
                    (errorDetails.message && errorDetails.message.includes('stock'))) {

                    // Show the stock error modal
                    setArchivedModalOpen(true);
                    setValidationError([]); // Clear any existing validation errors
                } else {
                    // For other errors, use existing validation error display
                    setValidationError([errorMsg]);
                    setSuccessMessage('');
                }
            }
        } catch (error) {
            console.error('Error archiving SPUs:', error);
            setValidationError(['An error occurred while archiving SPUs']);
            setSuccessMessage('');
        }
    }

    function showAlert(recordType, action, success = true) {
        let message = "";

        if (success) {
            if (action === "create") {
                message = `${recordType} is created successfully`;
            } else if (action === "update") {
                message = `${recordType} is updated`;
            } else if (action === "archive") {
                message = `${recordType} is archived successfully`;
            }
        } else {
            if (action === "create") {
                message = `Failed to create ${recordType}`;
            } else if (action === "update") {
                message = `Failed to update ${recordType}`;
            } else if (action === "archive") {
                message = `Failed to archive ${recordType}`;
            }
        }

        setAlert({
            message,
            type: success ? "success" : "error",
        });

        // auto close after 4s
        setTimeout(() => setAlert({ message: "", type: "" }), 4000);
    }
    const TYPE_CHIP_WIDTHS = { Device: 72, "Spare Part": 91, "Spare Parts": 91 };

    const columns = [
        {
            field: "model_name",
            label: "SPU Name",
            sortable: true,
            width: "13%",   // ← in %
            render: (row) => (
                <div className="name-cell" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                    <img
                        src={row?.images?.[0]?.spu_image_url || noImage}
                        alt="avatar"
                        className="avatar"
                        style={{
                            width: 32,
                            height: 32,
                            marginRight: 8,
                            flexShrink: 0,
                        }}
                    />
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
                        {row.model_name}
                    </span>
                </div>
            ),
        },

        { field: "status", label: "Status", sortable: true, width: "13%" },
        // OLD: simple brand text field (before brand_hierarchy)
        // { field: "brand_name", label: "Brand", sortable: true, width: "10%" },
        { field: "brand_name", label: "Brand", sortable: true, width: "10%" },
        { field: "category_name", label: "Category", sortable: true, width: "10%" },
        {
            field: "product_type", label: "Type", sortable: true, width: "14%", render: (row) => (
                <span style={{
                    backgroundColor: "#FFE84D",
                    borderRadius: "999px",
                    padding: "5px 10px",
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#212529",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                    height: 20,
                    boxSizing: "border-box",
                    ...(TYPE_CHIP_WIDTHS[row.product_type] ? { width: TYPE_CHIP_WIDTHS[row.product_type] } : {}),
                }}>
                    {row.product_type || "NA"}
                </span>
            ),
        },
        { field: "prefix", label: "Prefix", sortable: true, width: "10%" },
        { field: "model_id", label: "ID", sortable: true, width: "8%" },
        { field: "modified_at", label: "Last Modified Time", sortable: true, width: "15%", render: (row) => formatDateTime(row.modified_at), }

    ];

    // Update the archivedColumns to show correct fields:
    const archivedColumns = [
        {
            field: "model_name",
            label: "SPU Name",
            sortable: true,
            width: "15%",
            render: (row) => (
                <div className="name-cell" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                    <img
                        src={row?.images?.[0]?.spu_image_url || noImage}
                        alt="avatar"
                        className="avatar"
                        style={{
                            width: 32,
                            height: 32,
                            marginRight: 8,
                            flexShrink: 0,
                        }}
                    />
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
                        {row.model_name || <span style={{ color: '#B0B0B0' }}>NA</span>}
                    </span>
                </div>
            ),
        },
        // OLD: simple brand text render (before brand_hierarchy)
        // { field: "brand_name", label: "Brand", sortable: true, width: "12%",
        //   render: (row) => row.brand_name || <span style={{ color: '#B0B0B0' }}>NA</span> },
        {
            field: "brand_name",
            label: "Brand",
            sortable: true,
            width: "12%",
            render: (row) => row.brand_name || <span style={{ color: '#B0B0B0' }}>NA</span>,
        },
        {
            field: "category_name",
            label: "Category",
            sortable: true,
            width: "12%",
            render: (row) => row.category_name || <span style={{ color: '#B0B0B0' }}>NA</span>,
        },
        {
            field: "product_type",
            label: "Type",
            sortable: true,
            width: "12%",
            render: (row) => (
                <span style={{
                    backgroundColor: "#FFE84D",
                    borderRadius: "999px",
                    padding: "5px 10px",
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#212529",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                    height: 20,
                    boxSizing: "border-box",
                    ...(TYPE_CHIP_WIDTHS[row.product_type] ? { width: TYPE_CHIP_WIDTHS[row.product_type] } : {}),
                }}>
                    {row.product_type || "NA"}
                </span>),
        },
        {
            field: "prefix",
            label: "Prefix",
            sortable: true,
            width: "12%",
            render: (row) => row.prefix || <span style={{ color: '#B0B0B0' }}>NA</span>,
        },
        {
            field: "model_id",
            label: "ID",
            sortable: true,
            width: "12%",
            render: (row) => row.model_id || <span style={{ color: '#B0B0B0' }}>NA</span>,
        },
        {
            field: "archived_at",
            label: "Archived Time",
            sortable: true,
            width: "15%",
            render: (row) => formatDateTime(row.archived_at) || <span style={{ color: '#B0B0B0' }}>NA</span>,
        },
    ];

    const handleSort = (field) => {
        if (sortField === field) {
            if (sortOrder === "desc") {
                // If currently descending and clicked again, reset to default
                setSortField(null);
                setSortOrder("asc");
            } else {
                // Toggle between asc and desc
                setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
            }
        } else {
            // New field, start with asc
            setSortField(field);
            setSortOrder("asc");
        }
    };

    // Fix: Add handleSort function for archived table
    const handleArchivedSort = (field) => {
        setArchivedSortConfig(prev => {
            if (prev.key === field) {
                if (prev.direction === 'desc') {
                    // If currently descending and clicked again, reset to default
                    return { key: null, direction: 'asc' };
                } else {
                    // Toggle between asc and desc
                    return {
                        key: field,
                        direction: prev.direction === 'asc' ? 'desc' : 'asc'
                    };
                }
            } else {
                // New field, start with asc
                return {
                    key: field,
                    direction: 'asc'
                };
            }
        });
    };
    const isSearching = searchTerm.trim().length > 0;
    const isInitialTableEmpty = !isLoading && totalCount === 0 && !debouncedSearch && !filtersApplied;
    const isTableCompletelyEmpty = pageData?.length === 0;

    // Is table empty due to original dataset?
    // 1. Decide which image to show
    const emptyImage = isInitialTableEmpty
        ? noSpuImage                 // no data ever existed
        : emptySearchImg;              // search or filter result empty


    // 2. Decide title  
    const emptyTitle = isInitialTableEmpty
        ? "No SPU Found"
        : "No SPU Found";


    // 3. Decide message
    const emptyMessage = isInitialTableEmpty
        ? "Nothing here yet. Add your first item to get started!"
        : isSearching
            ? "No results match what you're looking for"
            : "No results match what you're looking for";

    // check if archived table has ZERO records initially
    const isInitialArchivedEmpty = activeTab === 'archived-spu' && archivedTotalCount === 0 && archivedSpus.length === 0 && !archivedDebouncedSearch && !archivedFiltersApplied;

    // archived search check
    const isArchivedSearching = archivedSearchTerm.trim() !== "";


    // Archived empty states (FIXED)
    const archivedEmptyImage = isInitialArchivedEmpty
        ? noSpuImage
        : emptySearchImg;

    const archivedEmptyTitle = isInitialArchivedEmpty
        ? "No Archived SPU found"  // ← FIXED: Changed from "No SPU Found"
        : "No Archived SPU found";  // ← FIXED: Changed from "No SPU found"

    const archivedEmptyMessage = isInitialArchivedEmpty
        ? "Nothing here yet. Add your first item to get started!"
        : isArchivedSearching
            ? "No results match what you're looking for"
            : "No results match what you're looking for";

    const FilterActiveIcon = () => (
        <svg style={{ margin: 0 }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g clipPath="url(#clip0_4516_4830)">
                <path d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z" fill="#0D6EFD" />
            </g>
            <defs>
                <clipPath id="clip0_4516_4830">
                    <rect width="12" height="12" fill="white" transform="translate(11 5)" />
                </clipPath>
            </defs>
        </svg>
    );

    const FilterInactiveIcon = () => (
        <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const FilterDisabledIcon = () => (
        <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#CED4DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#CED4DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    // All brands and categories from DB (not limited to current page's filter_options)
    const uniqueBrands = brandsData
        .map(b => ({
            id: b.brand_id,
            name: b.brand_name,
            original_logo_url: b.original_logo_url || null,
        }))
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));

    const uniqueCategories = categoriesData
        .map(c => ({
            id: c.category_id,
            name: c.category_name,
            title: c.category_name,
            category_name: c.category_name,
            parent_name: c.parent_name || null,
            parent_parent_name: c.parent_parent_name || null,
        }))
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
    const uniqueTypes = (filterOptions.types || []).sort((a, b) => {
        if ((a?.name || '').toLowerCase() === 'others') return 1;
        if ((b?.name || '').toLowerCase() === 'others') return -1;
        return (a?.name || '').localeCompare(b?.name || '');
    });

    const sections = [
        {
            label: "Status",
            type: "checkbox",
            key: "status",
            options: ["Active", "Inactive"],
        },

        {
            label: "Brand",
            type: "list",
            key: "brand",
            data: uniqueBrands,
            showDropdownIcon:true,
            renderItem: (item) => {
                const fullBrand = brandsData.find(b => b.brand_id === item.id);
                const hierarchy = fullBrand?.brand_hierarchy || [];
                const subtitle = hierarchy.length >= 1 ? hierarchy.map(b => b.name).join(' >> ') : null;
                return {
                    id: item?.id,
                    title: item?.name,
                    subtitle,
                    image:
                        item?.original_logo_url && item?.original_logo_url?.trim() !== ""
                            ? item?.original_logo_url
                            : noImage,
                };
            },
        },

        {
            label: "Category",
            type: "list",
            key: "category",
            data: uniqueCategories,
            showDropdownIcon:true,
            renderItem: (item) => {
                const fullCategory = categoriesData.find(cat => cat.category_id === item.id);
                const hierarchy = fullCategory?.category_hierarchy || [];
                const subtitle = hierarchy.length >= 1 ? hierarchy.map(c => c.name).join(' >> ') : null;
                return {
                    id: item.id,
                    title: fullCategory?.category_name || item.name,
                    subtitle,
                    image: null,
                };
            },
        },

        // ⭐ TYPE = OS TYPE ⭐
        {
            label: "Type",
            type: "simpleList",
            key: "type",
            data: uniqueTypes, // <-- from os_type
            // showDropdownIcon:true,
            renderItem: (item) => ({
                id: item?.id,
                title: item?.name,  // "Device", "Tablet", etc.
                subtitle: null,
                image: null,
            }),
        },
    ];

    // All brands from DB (archived filter)
    const uniqueArchivedBrands = brandsData
        .map(b => ({
            id: b.brand_id,
            name: b.brand_name,
            original_logo_url: b.original_logo_url || null,
        }))
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));

    // All categories from DB (archived filter)
    const uniqueArchivedCategories = categoriesData
        .map(c => ({
            id: c.category_id,
            name: c.category_name,
            title: c.category_name,
            category_name: c.category_name,
            parent_name: c.parent_name || null,
            parent_parent_name: c.parent_parent_name || null,
        }))
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));

    // ------------------------------
    // UNIQUE ARCHIVED TYPES (from server filter_options)
    // ------------------------------
    const uniqueArchivedTypes = (archivedFilterOptions.types || []).sort((a, b) => {
        if ((a?.name || "").toLowerCase() === "others") return 1;
        if ((b?.name || "").toLowerCase() === "others") return -1;
        if ((a?.name || "").toLowerCase() === "na") return 1;
        if ((b?.name || "").toLowerCase() === "na") return -1;
        return (a?.name || "").localeCompare((b?.name || ""));
    });

    const archivedFiltersections = [
        {
            label: "Brand",
            type: "list",
            key: "brand",
            data: uniqueArchivedBrands,
            showDropdownIcon:true,
            renderItem: (item) => {
                const fullBrand = brandsData.find(b => b.brand_id === item.id);
                const hierarchy = fullBrand?.brand_hierarchy || [];
                const subtitle = hierarchy.length >= 1 ? hierarchy.map(b => b.name).join(' >> ') : null;
                return {
                    id: item.id,
                    title: item.name,
                    subtitle,
                    image: item.original_logo_url || noImage,
                };
            },
        },
        {
            label: "Category",
            type: "list",
            key: "category",
            data: uniqueArchivedCategories,
            showDropdownIcon:true,
            renderItem: (item) => {
                const fullCategory = categoriesData.find(cat => cat.category_id === item.id);
                const hierarchy = fullCategory?.category_hierarchy || [];
                const subtitle = hierarchy.length >= 1 ? hierarchy.map(c => c.name).join(' >> ') : null;
                return {
                    id: item.id,
                    title: fullCategory?.category_name || item.title || '',
                    subtitle,
                    image: null,
                };
            },
        },
        {
            label: "Type",
            type: "simpleList",
            key: "type",
            data: uniqueArchivedTypes,
            renderItem: (item) => ({
                id: item.id,
                title: item.name,
                subtitle: null,
                image: null,
            }),
        }
    ];

    const baseURL = (process.env.REACT_APP_API_BASE_URL);
    console.log('this is the base url', baseURL);

    const isBrandNameOverflowing = (brandName) => {
        if (!brandName) return false;
        // Consider category name lengthy if it's more than 30 characters
        return brandName.length > 30;
    };
    const totalSkuVariations = skuVariations.length;

    const startIndex = (skuVariationPage - 1) * SKU_VARIATIONS_PER_PAGE;
    const endIndex = Math.min(
        startIndex + SKU_VARIATIONS_PER_PAGE,
        totalSkuVariations
    );

    const paginatedSkuVariations = skuVariations.slice(startIndex, endIndex);
    const totalSkuVariationsPages = Math.ceil(
        totalSkuVariations / SKU_VARIATIONS_PER_PAGE
    );

    const totalSkuConfigs = skuConfigurations.length;
    const totalSkuConfigPages = Math.ceil(
        totalSkuConfigs / SKU_CONFIGS_PER_PAGE
    );

    const configStartIndex =
        (skuConfigPage - 1) * SKU_CONFIGS_PER_PAGE;

    const configEndIndex = Math.min(
        configStartIndex + SKU_CONFIGS_PER_PAGE,
        totalSkuConfigs
    );

    const paginatedSkuConfigurations = skuConfigurations.slice(
        configStartIndex,
        configEndIndex
    );

    return (
        <div className="company-body new-look">
            <div className="breadcrumb">
                {breadcrumbs?.map((crumb, index) => (
                    <span key={index} className="breadcrumb-item">
                        {crumb}
                        {index !== breadcrumbs.length - 1}
                    </span>
                ))}
            </div>
            {showItemAlert && alert && (
                <AlertNotification
                    type={alert.type}
                    action={alert.action}
                    recordName={alert.recordName}
                    onClose={() => setShowItemAlert(false)}
                />
            )}


            <div className="employee-tabs-container">
                <div className="tabs">
                    <button
                        className={`tab ${activeTab === 'spu' ? 'active' : ''}`}
                        onClick={() => setActiveTab('spu')}
                    >
                        SPUs
                    </button>
                    <button
                        className={`tab ${activeTab === 'archived-spu' ? 'active' : ''}`}
                        onClick={() => setActiveTab('archived-spu')}
                    >
                        Archived SPUs
                    </button>
                </div>

                {activeTab === 'spu' && (
                    <div className="tab-content" id="spu-content">
                        <div className="info-section">
                            <div className="info-card">
                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <SearchBox
                                                searchInput={searchInput}
                                                setSearchInput={setSearchInput}
                                                setSearchTerm={setSearchTerm}
                                                setCurrentPage={setCurrentPage}
                                                disabled={isInitialTableEmpty}
                                            />

                                            <div style={{ position: 'relative' }}>

                                                <button
                                                    ref={filterButtonRef}
                                                    className={`icon-btn p-2 filter-btn ${filtersApplied ? "applied" : ""}`}
                                                    onClick={() => !isInitialTableEmpty && setFilterPopupOpen(!filterPopupOpen)}
                                                    disabled={isInitialTableEmpty}
                                                    style={{
                                                        border: isInitialTableEmpty
                                                            ? "1px solid var(--Gray-400, #CED4DA)"
                                                            : filtersApplied ? "1px solid #2C7BE5" : "1px solid #6C757D",
                                                        borderWidth: "1px",
                                                        color: isInitialTableEmpty ? "#CED4DA" : filtersApplied ? "#2C7BE5" : "#6C757D",

                                                        background: isInitialTableEmpty
                                                            ? "var(--Gray-100, #F8F9FA)" // disabled background
                                                            : filtersApplied
                                                                ? "#CFE2FF" // active filter
                                                                : "#FFFFFF", // normal

                                                        height: "40px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",

                                                        pointerEvents: isInitialTableEmpty ? "none" : "auto", // block actions
                                                        cursor: isInitialTableEmpty ? "not-allowed" : "pointer",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    {isInitialTableEmpty ? (
                                                        <FilterDisabledIcon />
                                                    ) : filtersApplied ? (
                                                        <FilterActiveIcon />
                                                    ) : (
                                                        <FilterInactiveIcon />
                                                    )}

                                                </button>

                                                <FilterDrawer
                                                    isOpen={filterPopupOpen}
                                                    onClose={() => {
                                                        setTempValues({
                                                            status: [],
                                                            brand: [],
                                                            category: [],
                                                            type: [],
                                                            brandSearch: "",
                                                            categorySearch: "",
                                                            typeSearch: "",
                                                        });

                                                        setFilterPopupOpen(false);
                                                    }}
                                                    sections={sections}
                                                    tempValues={tempValues}
                                                    setTempValues={setTempValues}
                                                    onApply={() => {
                                                        setCurrentPage(1);
                                                        setFilters({
                                                            status: tempValues.status || [],
                                                            brand: tempValues.brand || [],
                                                            category: tempValues.category || [],
                                                            type: tempValues.type || []
                                                        });
                                                        setFilterPopupOpen(false);
                                                    }}
                                                    onClear={() => {
                                                        const empty = {
                                                            status: [],
                                                            brand: [],
                                                            category: [],
                                                            type: [],
                                                            brandSearch: "",
                                                            categorySearch: "",
                                                            typeSearch: ""
                                                        };
                                                        setCurrentPage(1);
                                                        setTempValues(empty);
                                                        setFilters({
                                                            status: [],
                                                            brand: [],
                                                            category: [],
                                                            type: []
                                                        });
                                                    }}

                                                />

                                            </div>
                                        </div>
                                        {/* <div className="toolbar-right">

                                            <button
                                                className="icon-btn dark-border"
                                                onClick={() => history.push("/spu-sku/add-spu")}
                                            >
                                                <Plus size={18} /> Add SPU & SKU
                                            </button>
                                        </div> */}
                                        <div className="toolbar-right">

                                            <button
                                                disabled
                                                style={{
                                                    display: 'flex',
                                                    height: 34,
                                                    minWidth: 100,
                                                    padding: '10px',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 5,
                                                    borderRadius: 8,
                                                    border: '1px solid #CED4DA',
                                                    background: '#E9ECEF',
                                                    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.10)',
                                                    color: '#6C757D',
                                                    fontFamily: 'Montserrat',
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    cursor: 'not-allowed',
                                                }}
                                            >
                                                <Plus size={18} color="#6C757D" /> Add SPU & SKU
                                            </button>
                                        </div>
                                    </div>

                                    <div className="table-wrapper" style={{ border: "none" }}>
                                        <DynamicTable
                                            columns={columns}
                                            data={pageData}
                                            rowKey="spu_id"
                                            sortField={sortField}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            onRowClick={onRowClick}
                                            showCheckbox={false}
                                            selectedIds={selectedIds}
                                            toggleSelect={toggleSelect}
                                            toggleAll={toggleAll}
                                            dropdownOpenId={dropdownOpenId}
                                            suppressHighlight={suppressHighlight}
                                            buttonRefs={buttonRefs}
                                            onActionClick={(id) => toggleDropdown(id)}
                                            emptyImage={emptyImage}
                                            emptyTitle={emptyTitle}
                                            emptyMessage={emptyMessage}
                                            showActions={true}
                                            stickyColumns={1}
                                            resizableColumns={true}
                                        />


                                        {dropdownOpenId !== null && activeTab === 'spu' && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                onRowClick(currentRow);
                                                                setDropdownOpenId(null);
                                                            }}
                                                        >
                                                            View SPU Details
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() =>
                                                                history.push(`/inventory/spus/${currentRow.spu_id}/skus`, {
                                                                    spu: currentRow,
                                                                    activeTab,
                                                                    spuPage: currentPage,
                                                                    restoreTab: activeTab,
                                                                    fromDrawer: false
                                                                })
                                                            }
                                                        >
                                                            View All SKUs
                                                        </button>



                                                    </div>
                                                    <div className="common-for-all">
                                                        {/* <button
                                                            onClick={editSpu}
                                                        >
                                                            Edit SPU & SKU
                                                        </button> */}
                                                        <button
                                                            disabled
                                                            style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                        >
                                                            Edit SPU & SKU
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">

                                                        {/* {currentRow && (
                                                            <button
                                                                onClick={() => {
                                                                    if (currentRow.status === "Active" || currentRow.status_text === "Active") {
                                                                        handleDeactivateClick(currentRow.spu_id, false);
                                                                    } else {
                                                                        handleDeactivateClick(currentRow.spu_id, false);
                                                                    }
                                                                }}
                                                            >
                                                                {currentRow.status === "Active" || currentRow.status_text === "Active" ? "Deactivate" : "Activate"}
                                                            </button>
                                                        )} */}
                                                        {currentRow && (
                                                            <button
                                                                disabled
                                                                style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                            >
                                                                {currentRow.status === "Active" || currentRow.status_text === "Active" ? "Deactivate" : "Activate"}
                                                            </button>
                                                        )}
                                                    </div>

                                                </div>
                                                <div className="common-for-all">
                                                    {/* <button
                                                        onClick={() => handleArchiveClick(currentRow.spu_id, false)}
                                                        className="deactivate-cls"
                                                    >
                                                        Archive
                                                    </button> */}
                                                    <button
                                                        disabled
                                                        style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                    >
                                                        Archive
                                                    </button>

                                                </div>
                                            </div>
                                        )}

                                    </div>

                                    {totalCount > 0 && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, totalCount)} of ${totalCount} `}
                                            </div>
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                            />
                                        </div>
                                    )}
                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {brandDrawerOpen && <BrandInfoDrawer selectedRow={selectedBrandRow} setSelectedRow={setSelectedBrandRow} setBrandDrawerOpen={setBrandDrawerOpen} setSpuDrawerOpen={setDrawerOpen} brandsData={brandsData} setBrandsData={setBrandsData} />}

                        {categoryDrawerOpen && <CategoryInfoDrawer selectedRow={selectedCategoryRow} setSelectedRow={setSelectedCategoryRow} setCategoryDrawerOpen={setCategoryDrawerOpen} setSpuDrawerOpen={setDrawerOpen} categoriesData={categoriesData} setCategoriesData={setCategoriesData} />}

                        {!brandDrawerOpen && !categoryDrawerOpen && drawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" onClick={() => {
                                    setDrawerOpen(false);
                                    setSelectedRow(null);
                                }}
                                />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ background: "#F8F9FA" }}>
                                        <div className="d-flex align-items-center gap-1">
                                            {(location.search.includes('from=stocklist')) && (
                                                <button
                                                    className="back-btn"
                                                    onClick={() => {
                                                        if (location.search.includes('from=stocklist')) {
                                                            const query = new URLSearchParams(location.search);
                                                            const stockId = query.get('stockId');
                                                            const stockTab = query.get('stockTab');
                                                            const stockArchived = query.get('archived');
                                                            history.push(`/stock-list?id=${stockId}&autoOpen=true&archived=${stockArchived}&tab=${stockTab}`);
                                                            setDrawerOpen(false);
                                                            setSelectedRow(null);
                                                            setHasAutoOpened(false);
                                                        }
                                                    }}
                                                    style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                                >
                                                    <ChevronLeft size={24} />
                                                </button>
                                            )}
                                            <h3>SPU Info</h3>
                                        </div>
                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                setSelectedIds(ids => ids.filter(id => id !== selectedRow?.spu_id));
                                                setSelectedRow(null);
                                            }}
                                        >
                                            <X size={18} />
                                        </button>
                                    </div>
                                    <div className="main-drawer-inner" style={{
                                        marginTop: "35px",

                                    }}>
                                        <div className="drawer-title d-flex align-items-center justify-content-between"
                                            style={{
                                                borderBottom: "none",
                                                paddingBottom: "0px",
                                                boxShadow: "none",
                                                marginBottom: "0px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                            }}>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src={
                                                        selectedRow?.images && selectedRow?.images.length > 0
                                                            ? selectedRow.images[0].spu_image_url || noImage
                                                            : noImage
                                                    }
                                                    alt="avatar"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = noImage;
                                                    }}
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        marginRight: 8,
                                                        // objectFit: "cover",
                                                    }}
                                                />

                                                <h2 style={{ textTransform: 'none', }} className='pb-0'>{selectedRow?.model_name}</h2>
                                            </div>
                                            <div className='entities-tab'>
                                                <div className='toolbar'>
                                                    <div className="toolbar-right" style={{ position: "relative", flexWrap: "nowrap" }} ref={toolbarRef}>
                                                        <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'
                                                            style={{
                                                                flexShrink: 0,              // ✅ prevents collapse
                                                                whiteSpace: 'nowrap',       // ✅ keeps buttons inline
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                            }}

                                                        >
                                                            {/* <button
                                                                className="dark-border gray-btn"
                                                                type='button'
                                                                onClick={editSpu}
                                                                style={{ width: '115px', height: '34px', fontSize: '12px', fontStyle: 'normal', fontWeight: 600, lineHeight: 'normal' }}
                                                            >
                                                                Edit SPU & SKU
                                                            </button> */}
                                                            <button
                                                                disabled
                                                                type='button'
                                                                style={{
                                                                    display: 'flex', height: 34, minWidth: 115, padding: '10px',
                                                                    justifyContent: 'center', alignItems: 'center', gap: 5,
                                                                    borderRadius: 8, border: '1px solid #CED4DA', background: '#E9ECEF',
                                                                    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.10)', color: '#6C757D',
                                                                    fontFamily: 'Montserrat', fontSize: 12, fontWeight: 600, cursor: 'not-allowed',
                                                                }}
                                                            >
                                                                Edit SPU & SKU
                                                            </button>
                                                        </div>
                                                        <button
                                                            className="drawer-dots"
                                                            style={{ boxShadow: 'none' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleToolbarDropdown();
                                                            }}
                                                        >
                                                            <MoreHorizontal size={18} />
                                                        </button>

                                                        {toolbarDropdownOpen && (
                                                            <div
                                                                className="backdrop-cls"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 40,
                                                                    right: 0,
                                                                    background: "white",
                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                    zIndex: 1000,
                                                                    minWidth: 152,
                                                                    borderRadius: 8,
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div className="btn-align-forall">
                                                                    <div className="common-for-all">
                                                                        <button
                                                                            onClick={() => {
                                                                                if (!selectedRow?.spu_id) {
                                                                                    console.error("❌ currentRow undefined when clicking View All SKUs");
                                                                                    return;
                                                                                }
                                                                                history.push(`/inventory/spus/${selectedRow.spu_id}/skus`, {
                                                                                    spu: selectedRow,
                                                                                    activeTab,
                                                                                    spuPage: currentPage,
                                                                                    restoreTab: activeTab,
                                                                                    fromDrawer: true,
                                                                                    openSpuId: selectedRow.spu_id
                                                                                });
                                                                            }}
                                                                        >
                                                                            View All SKUs
                                                                        </button>
                                                                    </div>
                                                                    <div className="common-for-all">
                                                                        {/* <button
                                                                            onClick={() => {
                                                                                if (selectedRow.status === 'Active' || selectedRow.status_text === 'Active') {
                                                                                    handleDeactivateClick(selectedRow.spu_id, true);
                                                                                } else {
                                                                                    handleDeactivateClick(selectedRow.spu_id, true);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {(selectedRow.status === 'Active' || selectedRow.status_text === 'Active') ? 'Deactivate' : 'Activate'}
                                                                        </button> */}
                                                                        <button
                                                                            disabled
                                                                            style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                                        >
                                                                            {(selectedRow.status === 'Active' || selectedRow.status_text === 'Active') ? 'Deactivate' : 'Activate'}
                                                                        </button>
                                                                    </div>
                                                                    <div className="common-for-all">
                                                                        {/* <button
                                                                            onClick={() => handleArchiveClick(selectedRow.spu_id, true)}
                                                                            className="deactivate-cls"
                                                                        >
                                                                            Archive
                                                                        </button> */}
                                                                        <button
                                                                            disabled
                                                                            style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                                        >
                                                                            Archive
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="drawer-tabs" style={{
                                            borderBottom: "none",
                                            gap: "20px",
                                            paddingBottom: "15px"
                                        }}>
                                            <button
                                                className={drawerTab === 'general' ? 'active' : ''}
                                                onClick={() => setDrawerTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={drawerTab === 'additional-info' ? 'active' : ''}
                                                onClick={() => setDrawerTab('additional-info')}
                                            >
                                                Additional
                                            </button>
                                            <button
                                                className={drawerTab === 'sku-setup' ? 'active' : ''}
                                                onClick={() => setDrawerTab('sku-setup')}
                                            >
                                                SKU Setup
                                            </button>
                                        </div>

                                        <div className="drawer-content">
                                            {drawerTab === 'general' && (
                                                <div className="tab-panel general-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                            overflow: 'hidden',
                                                            marginBottom: '20px',
                                                            marginTop: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: ' #F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: ' #212529',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                alignSelf: 'stretch',
                                                                borderRadius: '12px 12px 0px 0px',
                                                                gap: '10px',
                                                                height: '50px',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Basic Info
                                                        </div>
                                                        {/* BODY */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '16px',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1 / -1' : '1',
                                                                gridRow: '1',
                                                                padding: '0'
                                                            }}>
                                                                <div className="field-label">SPU Name</div>
                                                                <div className="field-value" style={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.model_name || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1' : '2',
                                                                gridRow: isBrandNameOverflowing(selectedRow.model_name) ? '2' : '1',
                                                                padding: '0'
                                                            }}>
                                                                <div className="field-label">Prefix</div>
                                                                <div className="field-value" tyle={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.prefix || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                padding: '0'
                                                            }}>
                                                                <div className="field-label">Status</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${String(selectedRow?.status || '').toLowerCase()}`}>
                                                                        {selectedRow?.status || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    // gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                    padding: '0'
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.model_id || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0',
                                                                    gridColumn: '1 / -1',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>

                                                                <div className="field-value cell-wrapper">
                                                                    {selectedRow.uuid ? (
                                                                        <div className="value-container">
                                                                            <span
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                                className="value-clickable"
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            >
                                                                                {selectedRow.uuid}
                                                                            </span>
                                                                            <Copy
                                                                                size={13}
                                                                                className="copy-icon"
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            />
                                                                            {copied && <span className="copied-label">Copied!</span>}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0' }}>
                                                                <div className="field-label">Created By</div>
                                                                <div className="field-value">{selectedRow.created_by || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0', }}>
                                                                <div className="field-label">Created Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.created_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0', }}>
                                                                <div className="field-label">Last Modified By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.modified_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0', }}>
                                                                <div className="field-label">Last Modified Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* ===== Product INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Product Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                gap: '16px',
                                                                wordBreak: 'break-word',       // ✅ forces long words to break
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1 / -1' : '1',
                                                                    gridRow: '1',
                                                                    padding: '0',

                                                                    gridColumn: '1 / -1',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label">Brand</div>
                                                                {/* OLD brand display: logo + redirect link — commented out
                                                                <div className="field-value">
                                                                    {selectedRow.brand_name && selectedRow.brand_name !== 'NA' ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.brand_id
                                                                            );
                                                                            const parentLogo = parentBrandObj?.brand_logo || noImage;
                                                                            return (
                                                                                <div className="d-flex align-items-center">
                                                                                    <img src={selectedRow?.brand_logo || noImage} alt="parent brand logo" className="avatar"
                                                                                        style={{ width: 32, height: 32, marginRight: 10, flexShrink: 0, verticalAlign: 'middle' }} />
                                                                                    <div className="me-3" style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: 600, fontSize: '12px', cursor: 'pointer' }}
                                                                                        onClick={(e) => { e.stopPropagation(); setBrandDrawerOpen(true); }}>
                                                                                        <span>{selectedRow.brand_name}
                                                                                            <SquareArrowOutUpRight size={14} strokeWidth={3} style={{ marginLeft: '4px', verticalAlign: 'text-top', color: '#2C7BE5' }}
                                                                                                onClick={(e) => { e.stopPropagation(); if (selectedRow.brand_id) { history.push(`/brand?id=${selectedRow.brand_id}&autoOpen=true&from=spusku&spuId=${selectedRow.spu_id}&spuTab=${drawerTab}`); } }} />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })()
                                                                    ) : (<span style={{ color: '#B0B0B0' }}>NA</span>)}
                                                                </div>
                                                                END old brand display */}
                                                                <div className="field-value" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                    {selectedRow.brand_name
                                                                        ? selectedRow.brand_name
                                                                        : <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridRow: '2',
                                                                    padding: '0',

                                                                    gridColumn: '1 / -1',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label">Category</div>
                                                                <div className="field-value" style={{ height: '32px' }}>
                                                                    {selectedRow.category_name && selectedRow.category_name !== <span style={{ color: '#B0B0B0' }}>NA</span> ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.parent_brand
                                                                            );
                                                                            const parentLogo =
                                                                                parentBrandObj?.original_logo_url || noImage;

                                                                            return selectedRow.category_name;

                                                                            {/** * /}
                                                                            return (
                                                                                <div className="d-flex align-items-center" >
                                                                                    <div
                                                                                        className="me-3"
                                                                                        style={{
                                                                                            color: '#2C7BE5',
                                                                                            textDecoration: 'underline',
                                                                                            fontWeight: 600,
                                                                                            fontSize: '12px',
                                                                                            cursor: 'pointer',
                                                                                            lineHeight: '1.4',
                                                                                            maxWidth: '100%',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'anywhere',
                                                                                            whiteSpace: 'normal',

                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            setCategoryDrawerOpen(true);

                                                                                        }}
                                                                                    >
                                                                                        {/* ✅ text and icon in same inline flow * /}
                                                                                        <span style={{ display: 'inline', wordBreak: 'break-word' }}>
                                                                                            {selectedRow.category_name}
                                                                                            <SquareArrowOutUpRight
                                                                                                size={14}
                                                                                                strokeWidth={3}
                                                                                                style={{
                                                                                                    marginLeft: '4px',
                                                                                                    verticalAlign: 'text-top', // ✅ aligns nicely with text
                                                                                                    color: '#2C7BE5',
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    if (selectedRow.category_id) {
                                                                                                        history.push(
                                                                                                            `/category?id=${selectedRow.category_id}&autoOpen=true&from=spusku&spuId=${selectedRow.spu_id}&spuTab=${drawerTab}`
                                                                                                        );
                                                                                                    } else {
                                                                                                        console.warn('Parent brand not found in brandsData');
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                
                                                                                
                                                                            );
                                                                            {/*  */}
                                                                        })()
                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0',
                                                                    wordBreak: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}
                                                            >
                                                                <div className="field-label">Type</div>

                                                                <div className="field-value">

                                                                    {selectedRow.product_type ? (

                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                height: '20px',
                                                                                minWidth: '72px',
                                                                                padding: '5px 10px',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                gap: '5px',
                                                                                borderRadius: '99px',
                                                                                border: '1px solid #FFEB00',
                                                                                background: '#FFEB00',
                                                                                fontSize: '12px',
                                                                                fontWeight: 600,
                                                                                color: '#212529',
                                                                                width: 'fit-content',
                                                                            }}
                                                                        >
                                                                            {selectedRow?.product_type}
                                                                        </div>

                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}

                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Release Date</div>
                                                                <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Images</div>

                                                                {/* ---------------------- SPU IMAGES SECTION ---------------------- */}

                                                                {(() => {
                                                                    const hasImages =
                                                                        Array.isArray(selectedRow.images) && selectedRow.images.length > 0;

                                                                    return (
                                                                        <div
                                                                            className="field-value"
                                                                            style={{
                                                                                width: "100%",
                                                                                display: "flex",
                                                                                gap: 10,
                                                                                flexWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            {/* No images → fallback */}
                                                                            {!hasImages && (
                                                                                <img
                                                                                    src={noImage}
                                                                                    alt="no image"
                                                                                    style={{
                                                                                        width: 120,
                                                                                        height: 120,
                                                                                        objectFit: "cover",
                                                                                        borderRadius: 6,
                                                                                        opacity: 0.7,
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        setPreviewImages([noImage]);
                                                                                        setPreviewIndex(0);
                                                                                        setImageModalOpen(true);
                                                                                    }}
                                                                                />
                                                                            )}

                                                                            {/* Show images */}
                                                                            {hasImages &&
                                                                                selectedRow?.images?.map((imgObj, index) => {

                                                                                    // USE THE BACKEND URL NOW
                                                                                    const imageUrl = imgObj.spu_image_url;

                                                                                    return (
                                                                                        <img
                                                                                            key={imgObj.spu_image_id}
                                                                                            src={imageUrl}
                                                                                            alt="spu"
                                                                                            style={{
                                                                                                width: 120,
                                                                                                height: 120,
                                                                                                objectFit: "cover",
                                                                                                borderRadius: 6,
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                            onClick={() => {

                                                                                                // For preview, use backend URLs too
                                                                                                const previewList = selectedRow?.images?.map(
                                                                                                    (i) => i.spu_image_url
                                                                                                );

                                                                                                setPreviewImages(previewList);
                                                                                                setPreviewIndex(index);
                                                                                                setImageModalOpen(true);
                                                                                            }}
                                                                                            onError={(e) => (e.target.src = noImage)}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                        </div>
                                                                    );
                                                                })()}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {drawerTab === 'additional-info' && (
                                                <div className="tab-panel general-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '15px'
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                                height: '50px'
                                                            }}
                                                        >
                                                            Customised Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr',
                                                                gap: '16px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            {selectedRow?.custom_fields?.length > 0 ? (
                                                                selectedRow.custom_fields.map((field) => (
                                                                    <div
                                                                        key={field.field_id}
                                                                        className="field-block"
                                                                        style={{
                                                                            borderBottom: 'none',
                                                                            padding: '0',
                                                                            wordBreak: 'break-word',
                                                                            overflowWrap: 'break-word',
                                                                            whiteSpace: 'normal',
                                                                        }}
                                                                    >
                                                                        <div className="field-label">
                                                                            {field.field_name || 'NA'}
                                                                        </div>
                                                                        <div className="field-value">
                                                                            {field.field_data || (
                                                                                <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ color: '#ADB5BD' }}>No custom fields available</div>
                                                            )}
                                                        </div>

                                                    </div>

                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '40px',
                                                        }}
                                                    >
                                                        {/* ✅ Header: same style as Business Info */}
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                                height: '50px'
                                                            }}
                                                        >
                                                            Notes
                                                        </div>

                                                        {/* ✅ Body: matches layout and spacing */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '12px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{ padding: '0' }}>
                                                                <div
                                                                    className="field-value notes-preserve"
                                                                    style={{
                                                                        background: '#FFFFFF',
                                                                        padding: '0',
                                                                        fontSize: '13px',
                                                                        color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                        minHeight: '24px',
                                                                    }}
                                                                >
                                                                    {selectedRow.notes || 'NA'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {drawerTab === 'sku-setup' && (
                                                <div style={{ padding: "10px 0", display: "flex", flexDirection: "column", gap: "40px" }}>
                                                    {/* SKU VARIATIONS */}
                                                    <div className="card-section" style={{ borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', overflow: 'hidden' }}>
                                                        <div className="card-header" style={{ backgroundColor: '#F8F9FA', padding: '15px 20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, color: '#212529', borderBottom: 'none' }}>
                                                            SKU Variations
                                                        </div>

                                                        {/* Header Row */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "102px 1fr", background: "#E9ECEF", padding: "10px", fontWeight: 700, fontSize: "14px", margin: "10px", height: "45px", gap: '12px', alignItems: "center", color: "#212529" }}>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>SKU Variation</div>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>Variation Options</div>
                                                        </div>

                                                        {/* Variations Content */}
                                                        {Array.isArray(skuVariations) && skuVariations.length > 0 ? (
                                                            paginatedSkuVariations.map((item, index) => {
                                                                const rowBgColor = index % 2 === 0 ? '#FFFFFF' : '#F8F9FA';

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display: "grid",
                                                                            gridTemplateColumns: "120px 1fr",
                                                                            alignItems: "center",
                                                                            borderBottom: "1px solid #E9ECEF",
                                                                            gap: "12px",
                                                                            backgroundColor: rowBgColor,   // ✅ row bg applied
                                                                            marginLeft: '10px',
                                                                            marginRight: '10px',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className='text-center'
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                padding: '10px',
                                                                                color: '#212529',
                                                                                paddingLeft: '20px'
                                                                            }}
                                                                        >
                                                                            {item?.name || '—'}
                                                                        </div>

                                                                        <div
                                                                            className='text-center'
                                                                            style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                padding: '5px 10px',
                                                                                gap: "10px",
                                                                                // justifyContent: "center",
                                                                                color: "#212529"
                                                                            }}
                                                                        >
                                                                            {Array.isArray(item?.options) && item.options.length > 0 ? (
                                                                                item.options.map((opt, idx) => (
                                                                                    <span
                                                                                        key={idx}
                                                                                        style={{
                                                                                            background: "#FFEB3B",
                                                                                            padding: "5px 10px",
                                                                                            borderRadius: "99px",
                                                                                            fontWeight: 600,
                                                                                            fontSize: "12px",
                                                                                            display: "inline-block"
                                                                                        }}
                                                                                    >
                                                                                        {opt.label || 'Unknown'}
                                                                                    </span>
                                                                                ))
                                                                            ) : (
                                                                                <span style={{ fontSize: '12px', color: '#ADB5BD' }}>
                                                                                    NA
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div style={{ padding: "20px", textAlign: "center", color: "#6C757D" }}>
                                                                No SKU Variations Found
                                                            </div>
                                                        )}

                                                        {/* Footer Pagination */}

                                                        {totalSkuVariations > 0 && (
                                                            <div className="pagination" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <div className="pagination-info" style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingBottom: "10px", paddingRight: "10px" }}>
                                                                    {`${startIndex + 1} - ${endIndex} of ${totalSkuVariations}`}
                                                                </div>
                                                                <Pagination
                                                                    currentPage={skuVariationPage}
                                                                    totalPages={totalSkuVariationsPages}
                                                                    onPageChange={setSkuVariationPage}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* SKU CONFIGURATIONS - UPDATED to show SKU names */}
                                                    <div className="card-section" style={{ borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', overflow: 'hidden' }}>
                                                        <div className="card-header" style={{ backgroundColor: '#F8F9FA', padding: '15px 20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, color: '#212529', borderBottom: 'none' }}>
                                                            SKU Configurations
                                                        </div>

                                                        {totalSkuConfigs > 0 && (
                                                            <>
                                                            {/* Header Row */}
                                                            <div style={{ display: "grid", gridTemplateColumns: "130px 1fr", background: "#E9ECEF", padding: "10px", fontWeight: 700, fontSize: "14px", margin: "10px", height: "45px", gap: '12px', alignItems: "center", color: "#212529" }}>
                                                                <div style={{
                                                                    color: "#212529",
                                                                    textAlign: "center",
                                                                    fontFamily: "Montserrat",
                                                                    fontSize: "12px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: 700,
                                                                    lineHeight: "normal"
                                                                }} className='text-center'>Configuration Name</div>
                                                                <div style={{
                                                                    color: "#212529",
                                                                    textAlign: "center",
                                                                    fontFamily: "Montserrat",
                                                                    fontSize: "12px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: 700,
                                                                    lineHeight: "normal"
                                                                }} className='text-center'>Applied SKUs</div>
                                                            </div>
                                                            </>
                                                        )}

                                                        {/* Configurations Content */}
                                                        {Array.isArray(paginatedSkuConfigurations) &&
                                                            paginatedSkuConfigurations.length > 0 ? (
                                                            paginatedSkuConfigurations.map((cfg, index) => {
                                                                const rowBgColor =
                                                                    index % 2 === 0 ? "#FFFFFF" : "#F8F9FA";

                                                                const hasSkus =
                                                                    Array.isArray(cfg?.skus) && cfg.skus.length > 0;

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display: "grid",
                                                                            gridTemplateColumns: "120px 1fr",
                                                                            padding: "10px 0px",
                                                                            paddingLeft: "20px",
                                                                            borderBottom: "1px solid #E9ECEF",
                                                                            gap: "12px",
                                                                            margin: "0px 12px",
                                                                            backgroundColor: rowBgColor // ✅ zebra bg
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="text-center"
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                color: "#212529",
                                                                                wordBreak: "break-word",
                                                                                overflowWrap: "auto"
                                                                            }}
                                                                        >
                                                                            {cfg.configuration_name || (
                                                                                <span style={{ color: "#ADB5BD" }}>
                                                                                    Unknown Configuration
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div
                                                                            className="text-center"
                                                                            style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                gap: "2px",
                                                                                lineHeight: "20px",
                                                                                fontSize: "12px",
                                                                                color: "#212529",
                                                                                padding: "0px 10px",
                                                                                // justifyContent: "center"
                                                                            }}
                                                                        >
                                                                            {hasSkus ? (
                                                                                cfg.skus.map((sku, i) => (
                                                                                    <span
                                                                                        key={i}
                                                                                        style={{
                                                                                            fontSize: "12px",
                                                                                            margin: "2px"
                                                                                        }}
                                                                                    >
                                                                                        {sku.sku_name ||
                                                                                            sku.sku_code ||
                                                                                            `SKU ${sku.sku_id}`}
                                                                                    </span>
                                                                                ))
                                                                            ) : cfg.configuration_name ? (
                                                                                <span
                                                                                    style={{
                                                                                        color: "#6C757D",
                                                                                        fontStyle: "italic",
                                                                                        fontSize: "11px"
                                                                                    }}
                                                                                >
                                                                                    No SKUs assigned
                                                                                </span>
                                                                            ) : (
                                                                                <span style={{ color: "#ADB5BD" }}>NA</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="empty-state">
                                                                <div className="empty-state-content">
                                                                    <div className="icon">
                                                                        <img
                                                                            src={noBrandImage}
                                                                            alt="avatar"
                                                                            className="avatar"
                                                                            style={{ width: 120, height: 120 }}
                                                                        />
                                                                    </div>
                                                                    <h1 className="no-item-title mt-2">
                                                                        {/* No Configuration Applied */}
                                                                        No Related Configurations
                                                                    </h1>
                                                                    <p className="no-item-text">
                                                                        {/* No Configuration Applied to this SKU */}
                                                                        No Configurations defined under this SPU
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Footer Pagination */}
                                                        {totalSkuConfigs > SKU_CONFIGS_PER_PAGE && (
                                                            <div className="pagination" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <div className="pagination-info" style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "10px", paddingBottom: "10px" }}>
                                                                    {`${configStartIndex + 1} - ${configEndIndex} of ${totalSkuConfigs}`}
                                                                </div>
                                                                <Pagination
                                                                    currentPage={skuConfigPage}
                                                                    totalPages={totalSkuConfigPages}
                                                                    onPageChange={setSkuConfigPage}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Show simple count when items < 6 (for backward compatibility) */}
                                                        {totalSkuConfigs > 0 && totalSkuConfigs <= SKU_CONFIGS_PER_PAGE && (
                                                            <div style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "20px", paddingBottom: "10px" }}>
                                                                1 - {totalSkuConfigs} of {totalSkuConfigs}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {drawerTab === 'product-info' && (
                                                <div className="tab-panel product-info-panel">
                                                    <div className="field-block">
                                                        <div className="field-label">Brand</div>
                                                        {/* OLD brand display: clickable link — commented out
                                                        <div className="field-value">
                                                            {selectedRow.brand_name ? (
                                                                <div onClick={() => history.push(`/brand?id=${selectedRow.brand_id}&autoOpen=true&from=spusku&spuId=${selectedRow.spu_id}&spuTab=product-info`)}
                                                                    className="d-flex align-items-center gap-1 me-3"
                                                                    style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px', cursor: 'pointer' }}>
                                                                    {selectedRow.brand_name}
                                                                    <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                </div>
                                                            ) : <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                        </div>
                                                        END old brand display */}
                                                        <div className="field-value" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                                                            {selectedRow.brand_name
                                                                ? selectedRow.brand_name
                                                                : <span style={{ color: '#B0B0B0' }}>NA</span>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="field-block">
                                                        <div className="field-label">Category</div>
                                                        <div className="field-value">
                                                            {selectedRow.category_name ? (
                                                                <div
                                                                    onClick={async () => {
                                                                        try {

                                                                            history.push(`/category?id=${selectedRow.category_id}&autoOpen=true&from=spusku&spuId=${selectedRow.spu_id}&spuTab=product-info}`);
                                                                        } catch (error) {
                                                                            console.error('Failed to fetch category status:', error);
                                                                            // Fallback to original redirect
                                                                        }
                                                                    }}
                                                                    className="d-flex align-items-center gap-1 me-3"
                                                                    style={{
                                                                        color: '#2C7BE5',
                                                                        textDecoration: 'underline',
                                                                        fontWeight: '600',
                                                                        fontSize: '12px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {selectedRow.category_name}
                                                                    <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                </div>
                                                            ) : <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                        </div>
                                                    </div>

                                                    <div className="field-block">
                                                        <div className="field-label">Type</div>
                                                        <div className="field-value">
                                                            <div className="field-value">

                                                                {selectedRow.product_type ? (

                                                                    <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            height: '20px',
                                                                            minWidth: '72px',
                                                                            padding: '5px 10px',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            gap: '5px',
                                                                            borderRadius: '99px',
                                                                            border: '1px solid #FFEB00',
                                                                            background: '#FFEB00',
                                                                            fontSize: '12px',
                                                                            fontWeight: 600,
                                                                            color: '#212529',
                                                                            width: 'fit-content',
                                                                        }}
                                                                    >
                                                                        {selectedRow?.product_type}
                                                                    </div>

                                                                ) : (
                                                                    <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div className="field-label">Release Date</div>
                                                        <div className="field-value">
                                                            {selectedRow.spu_release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                        </div>
                                                    </div>

                                                    <div className="field-block">
                                                        <div className="field-label">Images</div>
                                                        <div className="field-value">
                                                            {selectedRow?.images[0] ? (
                                                                <div className="image-grid">
                                                                    {selectedRow?.images?.map((img, idx, allImgs) => (
                                                                        <img
                                                                            key={idx}
                                                                            src={img.image}
                                                                            alt={`spu-img-${idx}`}
                                                                            className="spu-img-thumb"
                                                                            onClick={() => {
                                                                                setPreviewImages(selectedRow.images);
                                                                                setPreviewIndex(idx);
                                                                                setImageModalOpen(true);
                                                                            }}
                                                                        />
                                                                    ))}
                                                                </div>) : <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                        </div>
                                                    </div>

                                                    <div className='main-company-body-inner'>
                                                        <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'>
                                                            <button
                                                                className="dark-button"
                                                                type='button'
                                                                onClick={() => {
                                                                    setSkuDrawerOpen(true);
                                                                    setDrawerOpen(false);
                                                                }}
                                                            >
                                                                View SKU
                                                            </button>
                                                            <button
                                                                className="dark-border gray-btn"
                                                                type='button'
                                                                onClick={() => setSaveModalOpen(true)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {imageModalOpen && (
                                                <div
                                                    style={{
                                                        position: "fixed",
                                                        inset: 0,
                                                        background: "rgba(0,0,0,0.35)",   // soft background blur/dim
                                                        backdropFilter: "blur(3px)",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        zIndex: 5000,
                                                    }}
                                                >
                                                    {/* WHITE CARD */}
                                                    <div
                                                        style={{
                                                            background: "#fff",
                                                            borderRadius: "16px",
                                                            padding: "24px",
                                                            maxWidth: "650px",
                                                            maxHeight: "80vh",
                                                            boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                                                            position: "relative",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {/* IMAGE */}
                                                        <img
                                                            src={previewImages[previewIndex]}
                                                            alt="preview"
                                                            style={{
                                                                maxWidth: "100%",
                                                                maxHeight: "70vh",
                                                                objectFit: "contain",
                                                                borderRadius: "12px",
                                                            }}
                                                        />

                                                        {/* CLOSE BUTTON */}
                                                        {/* CLOSE BUTTON – top-right of screen */}
                                                        <button
                                                            onClick={() => setImageModalOpen(false)}
                                                            style={{
                                                                position: "fixed",
                                                                top: "0px",
                                                                right: "0px",
                                                                background: "white",
                                                                width: "40px",
                                                                height: "40px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                border: "none",
                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                                                cursor: "pointer",
                                                                zIndex: 6000,
                                                            }}
                                                        >
                                                            <X size={22} />
                                                        </button>

                                                    </div>

                                                    {/* LEFT NAV */}
                                                    {previewImages.length > 1 && (
                                                        <button
                                                            onClick={() =>
                                                                setPreviewIndex((i) => (i - 1 + previewImages.length) % previewImages.length)
                                                            }
                                                            style={{
                                                                position: "fixed",
                                                                left: "0px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                background: "white",
                                                                width: "40px",
                                                                height: "40px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                border: "none",
                                                                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <ChevronLeft size={28} />
                                                        </button>
                                                    )}

                                                    {/* RIGHT NAV */}
                                                    {previewImages.length > 1 && (
                                                        <button
                                                            onClick={() =>
                                                                setPreviewIndex((i) => (i + 1) % previewImages.length)
                                                            }
                                                            style={{
                                                                position: "fixed",
                                                                right: "0px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                background: "white",
                                                                width: "40px",
                                                                height: "40px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                border: "none",
                                                                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <ChevronRight size={28} />
                                                        </button>
                                                    )}
                                                </div>
                                            )}

                                            {drawerTab === 'customised-info' && (
                                                <div className="tab-panel customised-info-panel">
                                                    {selectedRow?.custom_fields?.map((field, index) => (
                                                        <div className="field-block" key={index}>
                                                            <div className="field-label">{field.field_name || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            <div className="field-value">{field.field_data || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                        </div>
                                                    ))}
                                                    <div className='main-company-body-inner'>
                                                        <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'>
                                                            <button
                                                                className="dark-button"
                                                                type='button'
                                                                onClick={() => {
                                                                    setSkuDrawerOpen(true);
                                                                    setDrawerOpen(false);
                                                                }}
                                                            >
                                                                View SKU
                                                            </button>
                                                            <button
                                                                className="dark-border gray-btn"
                                                                type='button'
                                                                onClick={() => setSaveModalOpen(true)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {skuDrawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ background: "#F8F9FA" }}>
                                        <h3>SKU Info</h3>
                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setSkuDrawerOpen(false);
                                            }}
                                        >
                                            <X size={18} />
                                        </button>
                                    </div>

                                    <div className="main-drawer-inner">
                                        <div className="drawer-title d-flex align-items-center justify-content-between" style={{
                                            borderBottom: "none",
                                            paddingBottom: "15px",
                                            boxShadow: "none",
                                            marginBottom: "0px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                        }}>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src="https://www.sahivalue.com/product-images/IPHONE+16.jpg/293890000056884124/600x600"
                                                    alt="avatar"
                                                    className="avatar"
                                                    style={{ width: 40, height: 40, marginRight: 8 }}
                                                />
                                                <h2 style={{ textTransform: 'none', }} className="pb-0">{selectedRow?.spuName || <span style={{ color: '#B0B0B0' }}>NA</span>}</h2>
                                            </div>
                                            <div className='entities-tab'>
                                                <div className='toolbar'>
                                                    <div className="toolbar-right" style={{ position: "relative", flexWrap: "nowrap" }} ref={toolbarRef}>
                                                        <button
                                                            className="drawer-dots"
                                                            style={{ boxShadow: 'none' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleToolbarDropdown();
                                                            }}
                                                        >
                                                            <MoreHorizontal size={18} />
                                                        </button>

                                                        {toolbarDropdownOpen && (
                                                            <div
                                                                className="backdrop-cls"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 40,
                                                                    right: 0,
                                                                    background: "white",
                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                    zIndex: 1000,
                                                                    minWidth: 152,
                                                                    borderRadius: 8,
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div className="btn-align-forall">
                                                                    <div className="common-for-all">
                                                                        {/* <button onClick={() => {
                                                                            if (selectedSkuRow) {
                                                                                // handleSkuEnableDisableClick(selectedSkuRow.sku_id, true);
                                                                                setToolbarDropdownOpen(false);
                                                                            }
                                                                        }}>
                                                                            {selectedSkuRow?.status === 'Enabled' ||
                                                                                selectedSkuRow?.status === 'Active' ||
                                                                                selectedSkuRow?.status === true ||
                                                                                selectedSkuRow?.is_active === true ? 'Disable' : 'Enable'}
                                                                        </button> */}
                                                                        <button
                                                                            disabled
                                                                            style={{ color: '#6C757D', cursor: 'not-allowed', opacity: 0.6 }}
                                                                        >
                                                                            {selectedSkuRow?.status === 'Enabled' ||
                                                                                selectedSkuRow?.status === 'Active' ||
                                                                                selectedSkuRow?.status === true ||
                                                                                selectedSkuRow?.is_active === true ? 'Disable' : 'Enable'}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="drawer-tabs" style={{
                                            padding: " 10px",           // optional: top/bottom 0, left/right 20px
                                            borderBottom: "none",
                                            gap: "20px",
                                        }}>
                                            <button
                                                className={skuTab === 'general' ? 'active' : ''}
                                                onClick={() => setSkuTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={skuTab === 'configuration' ? 'active' : ''}
                                                onClick={() => setSkuTab('configuration')}
                                            >
                                                Configuration
                                            </button>
                                        </div>

                                        <div className="drawer-content">
                                            {skuTab === 'general' && (
                                                <div className="tab-panel general-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                            overflow: 'hidden',
                                                            marginBottom: '20px',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: ' #F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: ' #212529',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                alignSelf: 'stretch',
                                                                borderRadius: '12px 12px 0px 0px',
                                                                gap: '10px',
                                                                height: '50px',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Basic Info
                                                        </div>
                                                        {/* BODY */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '16px',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1 / -1' : '1',
                                                                gridRow: '1'
                                                            }}>
                                                                <div className="field-label">SKU Name</div>
                                                                <div className="field-value" style={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.model_name || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1' : '2',
                                                                gridRow: isBrandNameOverflowing(selectedRow.model_name) ? '2' : '1'
                                                            }}>
                                                                <div className="field-label">SKU Code</div>
                                                                <div className="field-value" tyle={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.prefix || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',

                                                            }}>
                                                                <div className="field-label">Color</div>
                                                                <div className="field-value">
                                                                    <span
                                                                        style={{
                                                                            background: "#FFEB3B",
                                                                            padding: "6px 18px",
                                                                            borderRadius: "20px",
                                                                            fontWeight: 600,
                                                                            fontSize: "13px",
                                                                            color: "#000",
                                                                            display: "inline-block",
                                                                            minWidth: "60px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {"Black" || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',

                                                            }}>
                                                                <div className="field-label">RAM</div>
                                                                <div className="field-value">
                                                                    <span
                                                                        style={{
                                                                            background: "#FFEB3B",
                                                                            padding: "6px 18px",
                                                                            borderRadius: "20px",
                                                                            fontWeight: 600,
                                                                            fontSize: "13px",
                                                                            color: "#000",
                                                                            display: "inline-block",
                                                                            minWidth: "60px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {"8G" || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',

                                                            }}>
                                                                <div className="field-label">RAM</div>
                                                                <div className="field-value">
                                                                    <span
                                                                        style={{
                                                                            background: "#FFEB3B",
                                                                            padding: "6px 18px",
                                                                            borderRadius: "20px",
                                                                            fontWeight: 600,
                                                                            fontSize: "13px",
                                                                            color: "#000",
                                                                            display: "inline-block",
                                                                            minWidth: "60px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {"8G" || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                            }}>
                                                                <div className="field-label">Storage</div>
                                                                <div className="field-value">
                                                                    <span
                                                                        style={{
                                                                            background: "#FFEB3B",
                                                                            padding: "6px 18px",
                                                                            borderRadius: "20px",
                                                                            fontWeight: 600,
                                                                            fontSize: "13px",
                                                                            color: "#000",
                                                                            display: "inline-block",
                                                                            minWidth: "60px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {"256GB" || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </span>

                                                                </div>
                                                            </div>

                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.uuid ? (
                                                                        <div className="field-value d-flex align-items-center gap-2">
                                                                            <span
                                                                                style={{
                                                                                    color: '#2C7BE5',
                                                                                    cursor: 'pointer',
                                                                                    textDecoration: 'underline',
                                                                                }}
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            >
                                                                                {selectedRow.uuid}
                                                                                <Copy
                                                                                    size={13}
                                                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                                                    style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                                                />
                                                                            </span>
                                                                            {copied && (
                                                                                <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                                                    Copied!
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Created By</div>
                                                                <div className="field-value">{selectedRow.created_by || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Created Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.created_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Last Modified By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.modified_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Last Modified Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* ===== Business INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Business Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                gap: '16px',
                                                                wordBreak: 'break-word',       // ✅ forces long words to break
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}>
                                                                <div className="field-label">GTIN</div>
                                                                <div className="field-value">{selectedRow.os_type || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">MSRP</div>
                                                                <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {skuTab === 'configuration' && (
                                                <div className="tab-panel configuration-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '40px',
                                                        }}
                                                    >
                                                        {/* ✅ Header: same style as Business Info */}
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Configuration Name
                                                        </div>

                                                        {/* ✅ Body: matches layout and spacing */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '12px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{ padding: "0px" }}>
                                                                <div
                                                                    className="field-value"
                                                                    style={{
                                                                        background: '#FFFFFF',
                                                                        // padding: '8px 0',
                                                                        fontSize: '13px',
                                                                        color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                        minHeight: '24px',
                                                                    }}
                                                                >
                                                                    {selectedRow.notes || 'NA'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Images
                                                        </div>
                                                        <div className="field-block" style={{ padding: "0px" }}>
                                                            <div className="image-grid" style={{ padding: '10px' }}>
                                                                {[1, 2, 3, 4].map((_, idx) => (
                                                                    <img
                                                                        key={idx}
                                                                        src="https://m.media-amazon.com/images/I/81CgtwSII3L._AC_SL1500_.jpg"
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{
                                                                            // maxWidth: 100,
                                                                            cursor: 'pointer',
                                                                            // borderRadius: '8px',
                                                                            width: 120,
                                                                            height: 120
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ===== Business INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Customised Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                gap: '16px',
                                                                wordBreak: 'break-word',       // ✅ forces long words to break
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}>
                                                                <div className="field-label">Monitor</div>
                                                                <div className="field-value">{selectedRow.os_type || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Processor</div>
                                                                <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '40px',
                                                        }}
                                                    >
                                                        {/* ✅ Header: same style as Business Info */}
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Notes
                                                        </div>

                                                        {/* ✅ Body: matches layout and spacing */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '12px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{ padding: "0px" }}>
                                                                <div
                                                                    className="field-value"
                                                                    style={{
                                                                        background: '#FFFFFF',
                                                                        // padding: '8px 0',
                                                                        fontSize: '13px',
                                                                        color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                        minHeight: '24px',
                                                                    }}
                                                                >
                                                                    {selectedRow.notes || 'NA'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {archivedModalOpen && (
                            <>
                                <div className="drawer-overlay" />
                                <div className="entity-drawer modal-popup-cls" ref={archivedRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}>
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>
                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>This SPU can't be archived</h3>
                                    <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
                                        This SPU can't be archived because it or its relevant SKUs is referenced by Stock or Pricing. Please remove or reassign this SPU or its SKUs before archiving.
                                    </p>
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={handleArchivedConfirm}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {activeTab === 'archived-spu' && (
                    <div className="tab-content" id="archived-spu-content">
                        <div className="info-section">
                            <div className="info-card">
                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <SearchBox
                                                searchInput={archivedSearchInput}
                                                setSearchInput={setArchivedSearchInput}
                                                setSearchTerm={setArchivedSearchTerm}
                                                setCurrentPage={setArchivedCurrentPage}
                                                placeholder="Search…"
                                                disabled={isInitialArchivedEmpty}
                                            />

                                            <div style={{ position: 'relative' }}>
                                                <button
                                                    ref={archivedFilterRef}
                                                    className={`icon-btn p-2 filter-btn ${archivedFiltersApplied ? "applied" : ""}`}
                                                    onClick={() => !isInitialArchivedEmpty && setArchivedFilterOpen(!archivedFilterOpen)}
                                                    disabled={isInitialArchivedEmpty}
                                                    style={{
                                                        border: isInitialArchivedEmpty
                                                            ? "1px solid var(--Gray-400, #CED4DA)"
                                                            : archivedFiltersApplied ? "1px solid #2C7BE5" : "1px solid #6C757D",
                                                        borderWidth: "1px",
                                                        color: isInitialArchivedEmpty ? "#CED4DA" : archivedFiltersApplied ? "#2C7BE5" : "#6C757D",

                                                        background: isInitialArchivedEmpty
                                                            ? "var(--Gray-100, #F8F9FA)" // disabled background
                                                            : archivedFiltersApplied
                                                                ? "#CFE2FF" // active filter
                                                                : "#FFFFFF", // normal

                                                        height: "40px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",

                                                        pointerEvents: isInitialArchivedEmpty ? "none" : "auto", // block actions
                                                        cursor: isInitialArchivedEmpty ? "not-allowed" : "pointer",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    {isInitialArchivedEmpty ? (
                                                        <FilterDisabledIcon />
                                                    ) : archivedFiltersApplied ? (
                                                        <FilterActiveIcon />
                                                    ) : (
                                                        <FilterInactiveIcon />
                                                    )}

                                                </button>
                                                <FilterDrawer
                                                    isOpen={archivedFilterOpen}
                                                    title="Filter"
                                                    onClose={() => {
                                                        const empty = {
                                                            brand: [],
                                                            category: [],
                                                            type: [],
                                                            brandSearch: "",
                                                            categorySearch: "",
                                                            typeSearch: ""
                                                        };

                                                        setTempArchivedValues(empty);
                                                        setArchivedFilters(empty);
                                                        setArchivedFilterOpen(false);
                                                    }}
                                                    sections={archivedFiltersections}
                                                    tempValues={tempArchivedValues}
                                                    setTempValues={setTempArchivedValues}
                                                    onApply={() => {
                                                        setArchivedCurrentPage(1);
                                                        setArchivedFilters({
                                                            brand: tempArchivedValues.brand,
                                                            category: tempArchivedValues.category,
                                                            type: tempArchivedValues.type,
                                                        });
                                                        setArchivedFilterOpen(false);
                                                    }}
                                                    onClear={() => {
                                                        const empty = {
                                                            brand: [],
                                                            category: [],
                                                            type: [],
                                                            brandSearch: "",
                                                            categorySearch: "",
                                                            typeSearch: ""
                                                        };
                                                        setArchivedCurrentPage(1);
                                                        setTempArchivedValues(empty);
                                                        setArchivedFilters(empty);
                                                    }}
                                                />


                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-wrapper" style={{ border: "none" }}>
                                        {/* Fix: Pass correct sorting props for archived table */}
                                        <DynamicTable
                                            columns={archivedColumns}
                                            data={archivedPageData}
                                            rowKey="spu_id"
                                            sortField={archivedSortConfig.key}  // Use archivedSortConfig.key
                                            sortOrder={archivedSortConfig.direction}  // Use archivedSortConfig.direction
                                            handleSort={handleArchivedSort}  // Use handleArchivedSort function
                                            onRowClick={onRowClick}
                                            showCheckbox={false}
                                            selectedIds={archivedSelectedIds}
                                            toggleSelect={toggleSelect}
                                            toggleAll={toggleAll}
                                            dropdownOpenId={dropdownOpenId}
                                            suppressHighlight={suppressHighlight}
                                            buttonRefs={buttonRefs}
                                            onActionClick={(id) => toggleDropdown(id)}
                                            emptyImage={archivedEmptyImage}
                                            emptyTitle={archivedEmptyTitle}
                                            emptyMessage={archivedEmptyMessage}
                                            showActions={true}
                                            stickyColumns={1}
                                            resizableColumns={true}
                                        />
                                        {dropdownOpenId !== null && activeTab === 'archived-spu' && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                onRowClick(currentRow);
                                                                setDropdownOpenId(null);
                                                            }}
                                                        >
                                                            View SPU Details
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() =>
                                                                history.push(`/inventory/spus/${currentRow.spu_id}/skus`, {
                                                                    spu: currentRow,
                                                                    activeTab,
                                                                    spuPage: archivedCurrentPage,
                                                                    restoreTab: activeTab,
                                                                    fromDrawer: false
                                                                })
                                                            }
                                                        >
                                                            View All SKUs
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {archivedTotalCount > 0 && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {`${(archivedCurrentPage - 1) * PAGE_SIZE + 1} - ${Math.min(archivedCurrentPage * PAGE_SIZE, archivedTotalCount)} of ${archivedTotalCount}`}
                                            </div>
                                            <Pagination
                                                currentPage={archivedCurrentPage}
                                                totalPages={archivedTotalPages}
                                                onPageChange={setArchivedCurrentPage}
                                            />
                                        </div>
                                    )}
                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>

                        {brandDrawerOpen && <BrandInfoDrawer selectedRow={selectedBrandRow} setSelectedRow={setSelectedBrandRow} setBrandDrawerOpen={setBrandDrawerOpen} setSpuDrawerOpen={setDrawerOpen} brandsData={brandsData} setBrandsData={setBrandsData} />}

                        {categoryDrawerOpen && <CategoryInfoDrawer selectedRow={selectedCategoryRow} setSelectedRow={setSelectedCategoryRow} setCategoryDrawerOpen={setCategoryDrawerOpen} setSpuDrawerOpen={setDrawerOpen} categoriesData={categoriesData} setCategoriesData={setCategoriesData} />}

                        {/* Single‐row Drawer (unchanged) */}
                        {!brandDrawerOpen && !categoryDrawerOpen && drawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" onClick={() => {
                                    setDrawerOpen(false);
                                    setSelectedRow(null);
                                }} />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ background: "#F8F9FA" }}>
                                        <h3>SPU Info</h3>
                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                setSelectedIds(ids => ids.filter(id => id !== selectedRow?.id));
                                                setSelectedRow(null);
                                            }}
                                        >
                                            <X size={24} />
                                        </button>
                                    </div>
                                    <div className="main-drawer-inner">
                                        <div className="drawer-title d-flex align-items-center justify-content-between" style={{
                                            borderBottom: "none",
                                            paddingBottom: "0px",
                                            boxShadow: "none",
                                            marginBottom: "0px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                        }}>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src={
                                                        selectedRow?.images && selectedRow?.images.length > 0
                                                            ? selectedRow.images[0].spu_image_url || noImage
                                                            : noImage
                                                    }
                                                    alt="avatar"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = noImage;
                                                    }}
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        marginRight: 8,
                                                        // objectFit: "cover",
                                                    }}
                                                />

                                                <h2 style={{ textTransform: 'none', }} className='pb-0'>{selectedRow?.model_name}</h2>
                                            </div>
                                            <div className='entities-tab'>
                                                <div className='toolbar'>
                                                    <div className="toolbar-right" style={{ position: "relative", flexWrap: "nowrap" }} ref={toolbarRef}>

                                                        <button
                                                            className="drawer-dots"
                                                            style={{ boxShadow: 'none' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleToolbarDropdown();
                                                            }}
                                                        >
                                                            <MoreHorizontal size={18} />
                                                        </button>

                                                        {toolbarDropdownOpen && (
                                                            <div
                                                                className="backdrop-cls"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 40,
                                                                    right: 0,
                                                                    background: "white",
                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                    zIndex: 1000,
                                                                    minWidth: 152,
                                                                    borderRadius: 8,
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div className="btn-align-forall">
                                                                    <div className="common-for-all">
                                                                        <button
                                                                            onClick={() =>
                                                                                history.push(`/inventory/spus/${selectedRow.spu_id}/skus`, {
                                                                                    spu: selectedRow,
                                                                                    activeTab,
                                                                                    spuPage: archivedCurrentPage,
                                                                                    restoreTab: activeTab,
                                                                                    fromDrawer: true,
                                                                                    openSpuId: selectedRow.spu_id
                                                                                })
                                                                            }
                                                                        >
                                                                            View All SKUs
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}


                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="drawer-tabs" style={{
                                            padding: " 10px",           // optional: top/bottom 0, left/right 20px
                                            borderBottom: "none",
                                            gap: "20px",
                                        }}>
                                            <button
                                                className={drawerTab === 'general' ? 'active' : ''}
                                                onClick={() => setDrawerTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={drawerTab === 'additional-info' ? 'active' : ''}
                                                onClick={() => setDrawerTab('additional-info')}
                                            >
                                                Additional
                                            </button>
                                            <button
                                                className={drawerTab === 'sku-setup' ? 'active' : ''}
                                                onClick={() => setDrawerTab('sku-setup')}
                                            >
                                                SKU Setup
                                            </button>
                                        </div>

                                        <div className="drawer-content">
                                            {drawerTab === 'general' && (
                                                <div className="tab-panel general-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                            overflow: 'hidden',
                                                            marginBottom: '20px',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: ' #F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: ' #212529',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                alignSelf: 'stretch',
                                                                borderRadius: '12px 12px 0px 0px',
                                                                gap: '10px',
                                                                height: '50px',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Basic Info
                                                        </div>
                                                        {/* BODY */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '20px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '20px',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1 / -1' : '1',
                                                                gridRow: '1',
                                                                padding: '0px'
                                                            }}>
                                                                <div className="field-label">SPU Name</div>
                                                                <div className="field-value" style={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.model_name || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1' : '2',
                                                                gridRow: isBrandNameOverflowing(selectedRow.model_name) ? '2' : '1',
                                                                padding: '0px',
                                                            }}>
                                                                <div className="field-label">Prefix</div>
                                                                <div className="field-value" tyle={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.prefix || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                    padding: '0px',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.model_id || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                    padding: '0px',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.uuid ? (
                                                                        <div className="field-value d-flex align-items-center gap-2">
                                                                            <span
                                                                                style={{
                                                                                    color: '#2C7BE5',
                                                                                    cursor: 'pointer',
                                                                                    textDecoration: 'underline',
                                                                                }}
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            >
                                                                                {selectedRow.uuid}
                                                                                <Copy
                                                                                    size={13}
                                                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                                                    style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                                                />
                                                                            </span>
                                                                            {copied && (
                                                                                <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                                                    Copied!
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Created By</div>
                                                                <div className="field-value">{selectedRow.created_by || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Created Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.created_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Last Modified By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.modified_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Last Modified Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Archived By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.archived_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: '0px' }}>
                                                                <div className="field-label">Archived Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.archived_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* ===== Product INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Product Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '20px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                gap: '20px',
                                                                wordBreak: 'break-word',       // ✅ forces long words to break
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1 / -1' : '1',
                                                                    gridRow: '1',
                                                                    padding: '0px',
                                                                    
                                                                    gridColumn: '1 / -1',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label">Brand</div>
                                                                {/* OLD brand display: logo + redirect link — commented out
                                                                <div className="field-value">
                                                                    {selectedRow.brand_name && selectedRow.brand_name !== 'NA' ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.brand_id
                                                                            );
                                                                            const parentLogo = parentBrandObj?.brand_logo || noImage;
                                                                            return (
                                                                                <div className="d-flex align-items-center">
                                                                                    <img src={selectedRow?.brand_logo || noImage} alt="parent brand logo" className="avatar"
                                                                                        style={{ width: 32, height: 32, marginRight: 10, flexShrink: 0, verticalAlign: 'middle' }} />
                                                                                    <div className="me-3" style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: 600, fontSize: '12px', cursor: 'pointer' }}
                                                                                        onClick={(e) => { e.stopPropagation(); setBrandDrawerOpen(true); }}>
                                                                                        <span>{selectedRow.brand_name}
                                                                                            <SquareArrowOutUpRight size={14} strokeWidth={3} style={{ marginLeft: '4px', verticalAlign: 'text-top', color: '#2C7BE5' }}
                                                                                                onClick={(e) => { e.stopPropagation(); setBrandDrawerOpen(true); }} />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })()
                                                                    ) : (<span style={{ color: '#B0B0B0' }}>NA</span>)}
                                                                </div>
                                                                END old brand display */}
                                                                <div className="field-value" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                    {selectedRow.brand_name
                                                                        ? selectedRow.brand_name
                                                                        : <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridRow: '2',
                                                                    padding: '0px',

                                                                    gridColumn: '1 / -1',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label">Category</div>
                                                                <div className="field-value" style={{ height: '32px' }}>
                                                                    {selectedRow.category_name && selectedRow.category_name !== <span style={{ color: '#B0B0B0' }}>NA</span> ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.parent_brand
                                                                            );
                                                                            const parentLogo =
                                                                                parentBrandObj?.original_logo_url || noImage;
                                                                            return selectedRow.category_name;
                                                                            {/** * /}
                                                                            return (
                                                                                <div className="d-flex align-items-center" >

                                                                                    <div
                                                                                        className="me-3"
                                                                                        style={{
                                                                                            color: '#2C7BE5',
                                                                                            textDecoration: 'underline',
                                                                                            fontWeight: 600,
                                                                                            fontSize: '12px',
                                                                                            cursor: 'pointer',
                                                                                            lineHeight: '1.4',
                                                                                            maxWidth: '100%',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'anywhere',
                                                                                            whiteSpace: 'normal',

                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            setCategoryDrawerOpen(true);
                                                                                        }}
                                                                                    >
                                                                                        {/* ✅ text and icon in same inline flow * /}
                                                                                        <span style={{ display: 'inline', wordBreak: 'break-word' }}>
                                                                                            {selectedRow.category_name}
                                                                                            <SquareArrowOutUpRight
                                                                                                size={14}
                                                                                                strokeWidth={3}
                                                                                                style={{
                                                                                                    marginLeft: '4px',
                                                                                                    verticalAlign: 'text-top', // ✅ aligns nicely with text
                                                                                                    color: '#2C7BE5',
                                                                                                }}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    setCategoryDrawerOpen(true);
                                                                                                }}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>



                                                                            );
                                                                            {/** */}

                                                                        })()
                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}>
                                                                <div className="field-label">Type</div>
                                                                <div className="field-value">

                                                                    {selectedRow.product_type ? (

                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                height: '20px',
                                                                                minWidth: '72px',
                                                                                padding: '5px 10px',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                gap: '5px',
                                                                                borderRadius: '99px',
                                                                                border: '1px solid #FFEB00',
                                                                                background: '#FFEB00',
                                                                                fontSize: '12px',
                                                                                fontWeight: 600,
                                                                                color: '#212529',
                                                                                width: 'fit-content',
                                                                            }}
                                                                        >
                                                                            {selectedRow?.product_type}
                                                                        </div>

                                                                    ) : (
                                                                        <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                    )}

                                                                </div>                                                            </div>
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Release Date</div>
                                                                <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Images</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {(() => {
                                                                        const hasImages =
                                                                            Array.isArray(selectedRow.images) && selectedRow.images.length > 0;

                                                                        return (
                                                                            <div
                                                                                className="field-value"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    display: "flex",
                                                                                    gap: 10,
                                                                                    flexWrap: "wrap",
                                                                                }}
                                                                            >
                                                                                {/* No images → fallback */}
                                                                                {!hasImages && (
                                                                                    <img
                                                                                        src={noImage}
                                                                                        alt="no image"
                                                                                        style={{
                                                                                            width: 120,
                                                                                            height: 120,
                                                                                            objectFit: "cover",
                                                                                            borderRadius: 6,
                                                                                            opacity: 0.7,
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setPreviewImages([noImage]);
                                                                                            setPreviewIndex(0);
                                                                                            setImageModalOpen(true);
                                                                                        }}
                                                                                    />
                                                                                )}

                                                                                {/* Show images */}
                                                                                {hasImages &&
                                                                                    selectedRow?.images?.map((imgObj, index) => {

                                                                                        // USE THE BACKEND URL NOW
                                                                                        const imageUrl = imgObj.spu_image_url;

                                                                                        return (
                                                                                            <img
                                                                                                key={imgObj.spu_image_id}
                                                                                                src={imageUrl}
                                                                                                alt="spu"
                                                                                                style={{
                                                                                                    width: 120,
                                                                                                    height: 120,
                                                                                                    objectFit: "cover",
                                                                                                    borderRadius: 6,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() => {

                                                                                                    // For preview, use backend URLs too
                                                                                                    const previewList = selectedRow?.images?.map(
                                                                                                        (i) => i.spu_image_url
                                                                                                    );

                                                                                                    setPreviewImages(previewList);
                                                                                                    setPreviewIndex(index);
                                                                                                    setImageModalOpen(true);
                                                                                                }}
                                                                                                onError={(e) => (e.target.src = noImage)}
                                                                                            />
                                                                                        );
                                                                                    })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {drawerTab === 'additional-info' && (
                                                <div className="tab-panel general-panel">
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Customised Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr',
                                                                gap: '16px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            {/* Dynamic custom fields rendering */}
                                                            {selectedRow?.custom_fields && selectedRow.custom_fields.length > 0 ? (
                                                                selectedRow?.custom_fields?.map((field, index) => (
                                                                    <div
                                                                        className="field-block"
                                                                        key={field.field_id || index}
                                                                        style={{
                                                                            borderBottom: 'none',
                                                                            padding: '0 10px',
                                                                            wordBreak: 'break-word',
                                                                            overflowWrap: 'break-word',
                                                                            whiteSpace: 'normal',
                                                                        }}
                                                                    >
                                                                        <div className="field-label">{field.field_name || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                        <div className="field-value">{field.field_data || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                // Fallback to hardcoded fields if no custom fields exist
                                                                <div style={{ color: '#ADB5BD' }}>No custom fields available</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Notes section remains the same */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                            marginTop: '40px',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            Notes
                                                        </div>
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '12px',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block" style={{ padding: '0' }}>
                                                                <div
                                                                    className="field-value notes-preserve"
                                                                    style={{
                                                                        background: '#FFFFFF',
                                                                        padding: '0',
                                                                        fontSize: '13px',
                                                                        color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                        minHeight: '24px',
                                                                    }}
                                                                >
                                                                    {selectedRow.notes || 'NA'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {drawerTab === 'sku-setup' && (
                                                <div style={{ padding: "10px 0", display: "flex", flexDirection: "column", gap: "40px" }}>
                                                    {/* SKU VARIATIONS */}
                                                    <div className="card-section" style={{ borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', overflow: 'hidden' }}>
                                                        <div className="card-header" style={{ backgroundColor: '#F8F9FA', padding: '15px 20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, color: '#212529', borderBottom: 'none' }}>
                                                            SKU Variations
                                                        </div>

                                                        {/* Header Row */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "102px 1fr", background: "#E9ECEF", padding: "10px", fontWeight: 700, fontSize: "14px", margin: "10px", height: "45px", gap: '12px', alignItems: "center", color: "#212529" }}>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>SKU Variation</div>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>Variation Options</div>
                                                        </div>

                                                        {/* Variations Content */}
                                                        {Array.isArray(skuVariations) && skuVariations.length > 0 ? (
                                                            // Use paginated data for archived SPU
                                                            paginatedSkuVariations.map((item, index) => {
                                                                const rowBgColor = index % 2 === 0 ? '#FFFFFF' : '#F8F9FA';

                                                                return (
                                                                    <div key={index} style={{
                                                                        display: "grid",
                                                                        gridTemplateColumns: "120px 1fr",
                                                                        alignItems: "center",
                                                                        padding: "10px 0px",
                                                                        borderBottom: "1px solid #E9ECEF",
                                                                        gap: '12px',
                                                                        backgroundColor: rowBgColor,
                                                                        margin: '0px 10px'
                                                                    }}>
                                                                        <div className='text-center' style={{ fontSize: "12px", fontWeight: 400, padding: '0px 10px', color: '#212529' }}>
                                                                            {item?.name || '—'}
                                                                        </div>
                                                                        <div className='text-center' style={{ display: "flex", flexWrap: "wrap", padding: '0px 10px', gap: "10px", justifyContent: "start" }}>
                                                                            {Array.isArray(item?.options) && item.options.length > 0 ? (
                                                                                item.options.map((opt, idx) => (
                                                                                    <span key={idx} style={{ background: "#FFEB3B", padding: "5px 10px", borderRadius: "99px", fontWeight: 600, fontSize: "12px", display: "inline-block" }}>
                                                                                        {opt.label || 'Unknown'}
                                                                                    </span>
                                                                                ))
                                                                            ) : (
                                                                                <span style={{ fontSize: '12px', color: '#ADB5BD' }}>NA</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div style={{ padding: "20px", textAlign: "center", color: "#6C757D" }}>
                                                                No SKU Variations Found
                                                            </div>
                                                        )}

                                                        {/* Footer Pagination - SHOW WHEN ITEMS >= 6 */}
                                                        {totalSkuVariations > SKU_VARIATIONS_PER_PAGE && (
                                                            <div className="pagination" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <div className="pagination-info" style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "10px", paddingBottom: "10px" }}>
                                                                    {`${startIndex + 1} - ${endIndex} of ${totalSkuVariations}`}
                                                                </div>
                                                                <Pagination
                                                                    currentPage={skuVariationPage}
                                                                    totalPages={totalSkuVariationsPages}
                                                                    onPageChange={setSkuVariationPage}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Show simple count when items < 6 (for backward compatibility) */}
                                                        {totalSkuVariations > 0 && totalSkuVariations <= SKU_VARIATIONS_PER_PAGE && (
                                                            <div style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "20px", paddingBottom: "10px" }}>
                                                                1 - {totalSkuVariations} of {totalSkuVariations}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* SKU CONFIGURATIONS */}
                                                    <div className="card-section" style={{ borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', overflow: 'hidden' }}>
                                                        <div className="card-header" style={{ backgroundColor: '#F8F9FA', padding: '15px 20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, color: '#212529', borderBottom: 'none' }}>
                                                            SKU Configurations
                                                        </div>

                                                        {/* Header Row */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "130px 1fr", background: "#E9ECEF", padding: "10px", fontWeight: 700, fontSize: "14px", margin: "10px", height: "45px", gap: '12px', alignItems: "center", color: "#212529" }}>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>Configuration Name</div>
                                                            <div style={{
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "normal"
                                                            }} className='text-center'>Applied SKUs</div>
                                                        </div>

                                                        {/* Configurations Content - Use paginated data */}
                                                        {Array.isArray(paginatedSkuConfigurations) && paginatedSkuConfigurations.length > 0 ? (
                                                            paginatedSkuConfigurations.map((cfg, index) => {
                                                                const rowBgColor = index % 2 === 0 ? "#FFFFFF" : "#F8F9FA";
                                                                const hasSkus = Array.isArray(cfg?.skus) && cfg.skus.length > 0;

                                                                return (
                                                                    <div key={index} style={{
                                                                        display: "grid",
                                                                        gridTemplateColumns: "120px 1fr",
                                                                        alignItems: "center",
                                                                        padding: "10px 0px",
                                                                        borderBottom: "1px solid #E9ECEF",
                                                                        gap: '12px',
                                                                        margin: '0px 12px',
                                                                        backgroundColor: rowBgColor
                                                                    }}>
                                                                        <div className='text-center' style={{
                                                                            fontSize: "12px",
                                                                            padding: '0px 10px',
                                                                            fontWeight: 400,
                                                                            color: '#212529',
                                                                            overflowWrap: "auto",
                                                                            wordBreak: "break-word"
                                                                        }}>
                                                                            {cfg.configuration_name || <span style={{ color: '#ADB5BD' }}>Unknown Configuration</span>}
                                                                        </div>
                                                                        <div className='text-center' style={{
                                                                            display: "flex",
                                                                            flexWrap: "wrap",
                                                                            gap: "2px",
                                                                            lineHeight: "20px",
                                                                            fontSize: "12px",
                                                                            color: "#212529",
                                                                            padding: '0px 10px'
                                                                        }}>
                                                                            {hasSkus ? (
                                                                                cfg.skus.map((sku, i) => (
                                                                                    <span key={i} style={{
                                                                                        fontSize: "12px",
                                                                                        color: '#212529',
                                                                                        display: "inline-block",
                                                                                        margin: '2px'
                                                                                    }}>
                                                                                        {sku.sku_name || sku.sku_code || `SKU ${sku.sku_id}`}
                                                                                    </span>
                                                                                ))
                                                                            ) : cfg.configuration_name ? (
                                                                                <span style={{ color: '#6C757D', fontStyle: 'italic', fontSize: '11px' }}>
                                                                                    No SKUs assigned
                                                                                </span>
                                                                            ) : (
                                                                                <span style={{ color: '#ADB5BD' }}>NA</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="empty-state">
                                                                <div className="empty-state-content">
                                                                    <div class="icon">
                                                                        <img
                                                                            src={noBrandImage}
                                                                            alt="avatar"
                                                                            className="avatar"
                                                                            style={{
                                                                                width: 120,
                                                                                height: 120,
                                                                                verticalAlign: 'middle'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <h1 class="no-item-title mt-2">
                                                                        No Configuration Applied
                                                                    </h1>
                                                                    <p class="no-item-text">
                                                                        No Configuration Applied to this SKU
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Footer Pagination - SHOW WHEN ITEMS >= 6 */}
                                                        {totalSkuConfigs > SKU_CONFIGS_PER_PAGE && (
                                                            <div className="pagination" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <div className="pagination-info" style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "10px", paddingBottom: "10px" }}>
                                                                    {`${configStartIndex + 1} - ${configEndIndex} of ${totalSkuConfigs}`}
                                                                </div>
                                                                <Pagination
                                                                    currentPage={skuConfigPage}
                                                                    totalPages={totalSkuConfigPages}
                                                                    onPageChange={setSkuConfigPage}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Show simple count when items < 6 (for backward compatibility) */}
                                                        {totalSkuConfigs > 0 && totalSkuConfigs <= SKU_CONFIGS_PER_PAGE && (
                                                            <div style={{ textAlign: "right", paddingTop: "10px", fontSize: "12px", color: "#6C757D", paddingRight: "20px", paddingBottom: "10px" }}>
                                                                1 - {totalSkuConfigs} of {totalSkuConfigs}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            {imageModalOpen && (
                                                <div className='image-modal' style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: 1050 }}>
                                                    <div className="drawer-overlay" />
                                                    <div
                                                        className="entity-drawer modal-popup-cls"
                                                        style={{
                                                            maxWidth: 750,
                                                            maxHeight: 750,
                                                            height: "100%",
                                                            justifyContent: "center",
                                                            background: "white",
                                                            borderRadius: 12,
                                                            zIndex: 1050,
                                                            padding: 24,
                                                            position: "fixed",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                        }}
                                                    >
                                                        <div className="image-modal-content d-flex justify-content-center align-items-center gap-3">
                                                            <img
                                                                src={previewImages[previewIndex]}
                                                                alt="preview"
                                                                style={{
                                                                    maxHeight: "600px",
                                                                    maxWidth: "100%",
                                                                    objectFit: "contain",
                                                                    margin: "auto",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Close button (top-right of viewport) */}
                                                    <button className="modal-close-absolute" onClick={() => setImageModalOpen(false)}>
                                                        <X size={28} />
                                                    </button>

                                                    {/* Left navigation (left of viewport) */}
                                                    <button
                                                        className="modal-nav-left"
                                                        onClick={() =>
                                                            setPreviewIndex((prev) => (prev - 1 + previewImages.length) % previewImages.length)
                                                        }
                                                    >
                                                        <ChevronLeft size={28} />
                                                    </button>

                                                    {/* Right navigation (right of viewport) */}
                                                    <button
                                                        className="modal-nav-right"
                                                        onClick={() =>
                                                            setPreviewIndex((prev) => (prev + 1) % previewImages.length)
                                                        }
                                                    >
                                                        <ChevronRight size={28} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </>
                        )}

                        {skuDrawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ background: '#F8F9FA' }}>
                                        <div className="d-flex align-items-center gap-1">
                                            <button
                                                className="back-btn"
                                                onClick={() => {
                                                    setSkuDrawerOpen(false);
                                                    setDrawerOpen(true);
                                                }}
                                                style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                            >
                                                <ChevronLeft />
                                            </button>
                                            <h3>SKU Info</h3>
                                        </div>

                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setSkuDrawerOpen(false);
                                            }}
                                        >
                                            <X size={24} />
                                        </button>
                                    </div>

                                    <div className="main-drawer-inner">
                                        <div className="drawer-title d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src="https://www.sahivalue.com/product-images/IPHONE+16.jpg/293890000056884124/600x600"
                                                    alt="avatar"
                                                    className="avatar"
                                                    style={{ width: 40, height: 40, marginRight: 8 }}
                                                />
                                                <h2 className="pb-0">{selectedRow?.spuName}</h2>
                                            </div>
                                        </div>

                                        <div className="drawer-tabs">
                                            <button
                                                className={skuTab === 'general' ? 'active' : ''}
                                                onClick={() => setSkuTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={skuTab === 'configuration' ? 'active' : ''}
                                                onClick={() => setSkuTab('configuration')}
                                            >
                                                Configuration
                                            </button>

                                        </div>

                                        <div className="drawer-content">
                                            <div className="drawer-content">
                                                {skuTab === 'general' && (
                                                    <div className="tab-panel general-panel">
                                                        <div
                                                            className="card-section"
                                                            style={{
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                                overflow: 'hidden',
                                                                marginBottom: '20px',
                                                                marginTop: '20px',
                                                            }}
                                                        >
                                                            <div
                                                                className="card-header"
                                                                style={{
                                                                    backgroundColor: ' #F8F9FA',
                                                                    padding: '15px 20px',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: ' #212529',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    alignSelf: 'stretch',
                                                                    borderRadius: '12px 12px 0px 0px',
                                                                    gap: '10px',
                                                                    height: '50px',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                Basic Info
                                                            </div>
                                                            {/* BODY */}
                                                            <div
                                                                className="card-body"
                                                                style={{
                                                                    backgroundColor: '#FFFFFF',
                                                                    padding: '16px',
                                                                    display: 'grid',
                                                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                                                    gap: '16px',
                                                                }}
                                                            >
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1 / -1' : '1',
                                                                    gridRow: '1'
                                                                }}>
                                                                    <div className="field-label">SKU Name</div>
                                                                    <div className="field-value" style={{
                                                                        wordWrap: 'break-word',
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal'
                                                                    }}>
                                                                        {selectedRow.model_name || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.model_name) ? '1' : '2',
                                                                    gridRow: isBrandNameOverflowing(selectedRow.model_name) ? '2' : '1'
                                                                }}>
                                                                    <div className="field-label">SKU Code</div>
                                                                    <div className="field-value" tyle={{
                                                                        wordWrap: 'break-word',
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal'
                                                                    }}>
                                                                        {selectedRow.prefix || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',

                                                                }}>
                                                                    <div className="field-label">Color</div>
                                                                    <div className="field-value">
                                                                        <span
                                                                            style={{
                                                                                background: "#FFEB3B",
                                                                                padding: "6px 18px",
                                                                                borderRadius: "20px",
                                                                                fontWeight: 600,
                                                                                fontSize: "13px",
                                                                                color: "#000",
                                                                                display: "inline-block",
                                                                                minWidth: "60px",
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            {selectedRow.status || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                        </span>

                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',

                                                                }}>
                                                                    <div className="field-label">RAM</div>
                                                                    <div className="field-value">
                                                                        <span
                                                                            style={{
                                                                                background: "#FFEB3B",
                                                                                padding: "6px 18px",
                                                                                borderRadius: "20px",
                                                                                fontWeight: 600,
                                                                                fontSize: "13px",
                                                                                color: "#000",
                                                                                display: "inline-block",
                                                                                minWidth: "60px",
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            {selectedRow.status || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                        </span>

                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                }}>
                                                                    <div className="field-label">RAM</div>
                                                                    <div className="field-value">
                                                                        <span
                                                                            style={{
                                                                                background: "#FFEB3B",
                                                                                padding: "6px 18px",
                                                                                borderRadius: "20px",
                                                                                fontWeight: 600,
                                                                                fontSize: "13px",
                                                                                color: "#000",
                                                                                display: "inline-block",
                                                                                minWidth: "60px",
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            {selectedRow.status || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                        </span>

                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                }}>
                                                                    <div className="field-label">Storage</div>
                                                                    <div className="field-value">
                                                                        <span
                                                                            style={{
                                                                                background: "#FFEB3B",
                                                                                padding: "6px 18px",
                                                                                borderRadius: "20px",
                                                                                fontWeight: 600,
                                                                                fontSize: "13px",
                                                                                color: "#000",
                                                                                display: "inline-block",
                                                                                minWidth: "60px",
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            {selectedRow.status || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                        </span>

                                                                    </div>
                                                                </div>

                                                                <div
                                                                    className="field-block"
                                                                    style={{
                                                                        borderBottom: 'none',
                                                                        padding: '9px 0',
                                                                        gridColumn: '1 / -1', // ✅ span both columns
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'flex-start',
                                                                        width: '100%',
                                                                    }}
                                                                >
                                                                    <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                                                    <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                        {selectedRow.uuid ? (
                                                                            <div className="field-value d-flex align-items-center gap-2">
                                                                                <span
                                                                                    style={{
                                                                                        color: '#2C7BE5',
                                                                                        cursor: 'pointer',
                                                                                        textDecoration: 'underline',
                                                                                    }}
                                                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                                                >
                                                                                    {selectedRow.uuid}
                                                                                    <Copy
                                                                                        size={13}
                                                                                        onClick={() => handleCopy(selectedRow.uuid)}
                                                                                        style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                                                    />
                                                                                </span>
                                                                                {copied && (
                                                                                    <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                                                        Copied!
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{ color: '#B0B0B0' }}>NA</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Created By</div>
                                                                    <div className="field-value">{selectedRow.created_by || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                </div>

                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Created Time</div>
                                                                    <div className="field-value">
                                                                        {formatDateTime(selectedRow.created_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Last Modified By</div>
                                                                    <div className="field-value">
                                                                        {selectedRow.modified_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Last Modified Time</div>
                                                                    <div className="field-value">
                                                                        {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Archived By</div>
                                                                    <div className="field-value">
                                                                        {selectedRow.modified_by || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                    <div className="field-label">Archived Time</div>
                                                                    <div className="field-value">
                                                                        {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#B0B0B0' }}>NA</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* ===== Business INFO CARD ===== */}
                                                        <div
                                                            className="card-section"
                                                            style={{
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                                overflow: 'hidden',
                                                            }}
                                                        >
                                                            <div
                                                                className="card-header"
                                                                style={{
                                                                    backgroundColor: '#F8F9FA',
                                                                    padding: '10px 16px',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#212529',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                Business Info
                                                            </div>

                                                            <div
                                                                className="card-body"
                                                                style={{
                                                                    backgroundColor: '#FFFFFF',
                                                                    padding: '16px',
                                                                    display: 'grid',
                                                                    gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                    gap: '16px',
                                                                    wordBreak: 'break-word',       // ✅ forces long words to break
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}
                                                            >

                                                                <div className="field-block"
                                                                    style={{
                                                                        borderBottom: 'none',
                                                                        padding: '9px 0px',
                                                                        wordBreak: 'break-word',       // ✅ added
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                    }}>
                                                                    <div className="field-label">GTIN</div>
                                                                    <div className="field-value">{selectedRow.os_type || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                </div>
                                                                <div className="field-block"
                                                                    style={{
                                                                        borderBottom: 'none',
                                                                        padding: '9px 0px',
                                                                        wordBreak: 'break-word',       // ✅ added
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                    }}

                                                                >
                                                                    <div className="field-label">MSRP</div>
                                                                    <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {skuTab === 'configuration' && (
                                                    <div className="tab-panel configuration-panel">
                                                        <div
                                                            className="card-section"
                                                            style={{
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                                overflow: 'hidden',
                                                                marginTop: '40px',
                                                            }}
                                                        >
                                                            {/* ✅ Header: same style as Business Info */}
                                                            <div
                                                                className="card-header"
                                                                style={{
                                                                    backgroundColor: '#F8F9FA',
                                                                    padding: '10px 16px',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#212529',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                Configuration Name
                                                            </div>

                                                            {/* ✅ Body: matches layout and spacing */}
                                                            <div
                                                                className="card-body"
                                                                style={{
                                                                    backgroundColor: '#FFFFFF',
                                                                    padding: '16px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: '12px',
                                                                    wordBreak: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}
                                                            >
                                                                <div className="field-block" style={{ padding: "0px" }}>
                                                                    <div
                                                                        className="field-value"
                                                                        style={{
                                                                            background: '#FFFFFF',
                                                                            // padding: '8px 0',
                                                                            fontSize: '13px',
                                                                            color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                            minHeight: '24px',
                                                                        }}
                                                                    >
                                                                        {selectedRow.notes || 'NA'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* ===== Business INFO CARD ===== */}
                                                        <div
                                                            className="card-section"
                                                            style={{
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                                overflow: 'hidden',
                                                                marginTop: '20px',
                                                            }}
                                                        >
                                                            <div
                                                                className="card-header"
                                                                style={{
                                                                    backgroundColor: '#F8F9FA',
                                                                    padding: '10px 16px',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#212529',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                Customised Info
                                                            </div>

                                                            <div
                                                                className="card-body"
                                                                style={{
                                                                    backgroundColor: '#FFFFFF',
                                                                    padding: '16px',
                                                                    display: 'grid',
                                                                    gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                    gap: '16px',
                                                                    wordBreak: 'break-word',       // ✅ forces long words to break
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}
                                                            >

                                                                <div className="field-block"
                                                                    style={{
                                                                        borderBottom: 'none',
                                                                        padding: '9px 0px',
                                                                        wordBreak: 'break-word',       // ✅ added
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                    }}>
                                                                    <div className="field-label">Monitor</div>
                                                                    <div className="field-value">{selectedRow.product_type || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                </div>
                                                                <div className="field-block"
                                                                    style={{
                                                                        borderBottom: 'none',
                                                                        padding: '9px 0px',
                                                                        wordBreak: 'break-word',       // ✅ added
                                                                        overflowWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                    }}

                                                                >
                                                                    <div className="field-label">Processor</div>
                                                                    <div className="field-value">{selectedRow.release_date || <span style={{ color: '#B0B0B0' }}>NA</span>}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="card-section"
                                                            style={{
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                                overflow: 'hidden',
                                                                marginTop: '40px',
                                                            }}
                                                        >
                                                            {/* ✅ Header: same style as Business Info */}
                                                            <div
                                                                className="card-header"
                                                                style={{
                                                                    backgroundColor: '#F8F9FA',
                                                                    padding: '10px 16px',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#212529',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                Notes
                                                            </div>

                                                            {/* ✅ Body: matches layout and spacing */}
                                                            <div
                                                                className="card-body"
                                                                style={{
                                                                    backgroundColor: '#FFFFFF',
                                                                    padding: '16px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: '12px',
                                                                    wordBreak: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}
                                                            >
                                                                <div className="field-block" style={{ padding: "0px" }}>
                                                                    <div
                                                                        className="field-value notes-preserve"
                                                                        style={{
                                                                            background: '#FFFFFF',
                                                                            // padding: '8px 0',
                                                                            fontSize: '13px',
                                                                            color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                            minHeight: '24px',
                                                                        }}
                                                                    >
                                                                        {selectedRow.notes || 'NA'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {/* Deactivate/Activate Confirmation Modal */}
                {/* Add this with the other modals at the end of the JSX (around line 2550) */}

                <ConfirmDeactivateModal
                    isOpen={deactivateModalOpen}
                    onCancel={() => {
                        setDeactivateModalOpen(false);
                        setActionSpuId(null);
                    }}
                    onConfirm={handleConfirmDeactivate}
                    entityName="SPU"
                />

                {/* Archive Confirmation Modal */}
                <ConfirmArchiveModal
                    isOpen={archiveModalOpen}
                    onCancel={() => {
                        setArchiveModalOpen(false);
                        setActionSpuId(null);
                    }}
                    onConfirm={handleConfirmArchive}
                    entityName="SPU and its SKUs"
                />

                {/* Notification Toast */}
                {notification.show && (
                    <AlertNotification
                        type={notification.type}
                        recordName={notification.recordName}
                        action={notification.action}
                        onClose={handleCloseNotification}
                    />
                )}
            </div>

            <style>{`
    .cell-wrapper {
  width: 100%;
  word-break: break-all;
  cursor: text;          /* ⬅ user can select text in empty area */
}

.value-container {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.value-clickable {
  color: #2C7BE5;
  text-decoration: underline;
  cursor: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E%E2%9C%8B%3C/text%3E%3C/svg%3E") 12 12, pointer;
}

.copy-icon {
  cursor: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E%E2%9C%8B%3C/text%3E%3C/svg%3E") 12 12, pointer;
}

.copied-label {
  font-size: 12px;
  color: #2C7BE5;
}

/* Matches Stock List / Brand's Action column width exactly. */
.entities-table .actionHeader {
  width: 56px;
  min-width: 56px;
  max-width: 56px;
}

/* Fixed-column shadows — anchored to the sticky column itself so they stay
   correctly placed at any scroll offset, and spill onto the scrollable
   content the fixed column is floating above. Only shown while something is
   actually scrolled behind it. */
.entities-table.is-scrolled-right th.actionHeader::before,
.entities-table.is-scrolled-right td.actionColumn::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 0;
  width: 8px;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
}

.entities-table.is-scrolled-left th:nth-child(1)::after,
.entities-table.is-scrolled-left td:nth-child(1)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -8px;
  width: 8px;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
}

/* SPU Name's cell clips via its own inner span (see columns/archivedColumns
   render above), so the outer td can safely allow overflow here without
   losing text truncation — needed so the shadow above isn't cut off by the
   td's own overflow:hidden. */
.entities-table.is-scrolled-left td:nth-child(1) {
  overflow: visible !important;
}

/* Grip mark on each column's resize handle, so users can spot where to drag
   without having to hover first. */
.col-resize-handle::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
  left: 3px;
  width: 2px;
  background: #DEE2E6;
}


   `}</style>
        </div>
    );
};